/**
 * BOGO Landing Page v4 — Multi-Collection + Brand-Aware
 * MassDeals.in
 * 
 * New in v4:
 * - Multiple collections support (fetch, merge, dedupe)
 * - Brand filter pills (auto-populated from product vendors)
 * - Dual size system: Crocs (smart M/W/C/J) + Other brands (raw UK sizes)
 * - Brand-aware size charts (Crocs built-in, others open external page)
 * - Gender detection: Crocs from size prefix, others from option2
 * - Cross-collection BOGO pairing (any Item 1 + any Item 2)
 */
(function() {
  'use strict';

  // ===========================================
  // CONFIG
  // ===========================================
  const CONFIG = {
    PRODUCTS_PER_PAGE: 250,
    DISPLAY_PER_LOAD: 12,
    DEBUG: (function() {
      try { return new URLSearchParams(window.location.search).has('bogo_debug'); }
      catch(e) { return false; }
    })()
  };

  function log(...args) {
    if (CONFIG.DEBUG) console.log('[BOGO]', ...args);
  }

  // Compat helpers for budget phones (no optional chaining)
  function safeOn(id, event, handler) {
    var el = document.getElementById(id);
    if (el) el.addEventListener(event, handler);
  }
  function getImgUrl(product) {
    if (!product || !product.images || !product.images[0]) return '';
    // Use .src (already cached by grid) instead of .thumb (different URL, uncached)
    return product.images[0].src || '';
  }

  // v4.3: Style H — Minimal Outlined circle icons
  // active=true: filled navy circle, white letter
  // active=false: outlined circle (#c8c5d9), navy letter
  function styleHIcon(size, letter, star, active) {
    var vb = 48;
    var circleFill = active ? '#1e1b4b' : 'none';
    var circleStroke = active ? '#1e1b4b' : '#c8c5d9';
    var textFill = active ? '#fff' : '#1e1b4b';
    var svg = '<svg width="' + size + '" height="' + size + '" viewBox="0 0 ' + vb + ' ' + vb + '" fill="none" style="display:inline-block;vertical-align:middle;">';
    svg += '<circle cx="24" cy="24" r="22" fill="' + circleFill + '" stroke="' + circleStroke + '" stroke-width="2"/>';
    svg += '<text x="24" y="31" text-anchor="middle" font-family="\'Segoe UI\',system-ui,sans-serif" font-size="20" font-weight="700" fill="' + textFill + '" letter-spacing="1">' + letter + '</text>';
    if (star) {
      svg += '<circle cx="37" cy="10" r="4" fill="#d4851f"/>';
    }
    if (active) {
      svg += '<circle cx="24" cy="46" r="2.5" fill="#f97316"/>';
    }
    svg += '</svg>';
    return svg;
  }

  // ===========================================
  // STATE
  // ===========================================
  const state = {
    collectionHandles: [],       // v4: array of collection handles
    collectionNames: [],         // v4: display names from schema
    allProducts: [],
    allSizes: { men: [], women: [], kids: [] },
    isLoading: false,
    isFetched: false,
    fetchError: null,
    
    activeCategory: 'men',
    selectedBrands: [],              // v5: array for multi-brand, empty = all
    availableBrands: [],         // v4: auto-populated
    filterPanelOpen: false,      // v5: filter panel state
    selectedSizes: { men: [], women: [], kids: [] },
    selectedTypes: { men: 'All', women: 'All', kids: 'All' },
    
    filteredProducts: [],
    displayedCount: 0,
    availableTypes: [],
    
    bogoSelection: { first: null, second: null },
    _pendingReplaceItem: null,   // v5: holds 3rd item while replace modal is open
    cartPairs: [],
    currentPairNum: 1,
    
    quickViewProduct: null,
    quickViewSelectedSize: null,
    quickViewImageIndex: 0,
    
    zoomImages: [],
    zoomIndex: 0,
    
    recentlyViewed: [],
    sortOrder: 'default',
    nudgeTimer: null,
    _savedScrollY: null,
  };

  // ===========================================
  // SCROLL LOCK + THEME HEADER HIDE (mobile-safe)
  // ===========================================
  var _scrollLockCount = 0;
  function lockScroll() {
    _scrollLockCount++;
    if (_scrollLockCount > 1) return; // already locked
    var scrollY = window.scrollY || window.pageYOffset;
    document.body.dataset.bogoScrollY = scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    // Hide ALL theme elements that could overlap modals
    var selectors = [
      '#shopify-section-header',
      '#shopify-section-announcement-bar',
      '#shopify-section-footer',
      '#shopify-section-footer-promotions',
      'header.site-header',
      'header.header',
      '.header-wrapper',
      '.announcement-bar',
      'sticky-header',
      '.shopify-section-header',
      '.shopify-section-footer',
      'footer.site-footer',
      'footer.footer',
      '.footer-wrapper'
    ];
    selectors.forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el && !el.dataset.bogoHidden) {
        el.dataset.bogoHidden = '1';
        el.dataset.bogoOldDisplay = el.style.display || '';
        el.style.setProperty('display', 'none', 'important');
      }
    });
    // Fallback: first <header> and <footer> tags
    var h = document.querySelector('header');
    if (h && !h.dataset.bogoHidden) {
      h.dataset.bogoHidden = '1';
      h.dataset.bogoOldDisplay = h.style.display || '';
      h.style.setProperty('display', 'none', 'important');
    }
    var f = document.querySelector('footer');
    if (f && !f.dataset.bogoHidden) {
      f.dataset.bogoHidden = '1';
      f.dataset.bogoOldDisplay = f.style.display || '';
      f.style.setProperty('display', 'none', 'important');
    }
  }
  function unlockScroll() {
    _scrollLockCount = Math.max(0, _scrollLockCount - 1);
    if (_scrollLockCount > 0) return; // still has active modals
    var scrollY = parseInt(document.body.dataset.bogoScrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
    // Restore ALL hidden theme elements
    document.querySelectorAll('[data-bogo-hidden="1"]').forEach(function(el) {
      var old = el.dataset.bogoOldDisplay;
      if (old) {
        el.style.display = old;
      } else {
        el.style.removeProperty('display');
      }
      delete el.dataset.bogoHidden;
      delete el.dataset.bogoOldDisplay;
    });
  }

  // ===========================================
  // BRAND SIZE CHARTS
  // ===========================================
  const BRAND_SIZE_CHARTS = {
    'crocs':        null,
    'asics':        '/pages/asics-size-chart',
    'new balance':  '/pages/new-balance-size-chart',
    'nike':         '/pages/nike-size-chart',
    'reebok':       '/pages/reebok-size-chart',
    'under armour': '/pages/under-armour-size-chart',
    'woodland':     '/pages/woodland-size-chart',
    'skechers':     '/pages/skechers-size-chart',
    'adidas':       '/pages/adidas-size-chart',
    'comet':        null,
    'on':           null,
  };

  function loadSchemaBrandCharts() {
    const el = document.getElementById('brand-charts-data');
    if (!el) return;
    try {
      const data = JSON.parse(el.textContent);
      Object.entries(data).forEach(([brand, url]) => {
        if (brand && url) BRAND_SIZE_CHARTS[brand.toLowerCase().trim()] = url;
      });
    } catch(e) { log('Brand chart data parse error:', e); }
  }

  function getBrandChartUrl(vendor) {
    if (!vendor) return null;
    const v = vendor.toLowerCase().trim();
    if (v in BRAND_SIZE_CHARTS) return BRAND_SIZE_CHARTS[v];
    for (const [brand, url] of Object.entries(BRAND_SIZE_CHARTS)) {
      if (v.includes(brand) || brand.includes(v)) return url;
    }
    return null;
  }

  // ===========================================
  // BRAND HELPERS
  // ===========================================
  function isCrocsBrand(vendor) {
    return vendor && vendor.toLowerCase().trim() === 'crocs';
  }

  // Does this look like a Crocs-format size? (M5, W7, M5W7, C10, J3)
  function isCrocsSize(size) {
    if (!size) return false;
    const s = size.toUpperCase();
    return /^[MWCJ]\d/.test(s);
  }

  // ===========================================
  // CROCS ↔ UK SIZE CONVERSION (v4.1)
  // Used when brand="All" to show cross-brand results
  // ===========================================
  const CROCS_TO_UK = {
    men: { M2:'UK1', M3:'UK2', M4:'UK3', M5:'UK4', M6:'UK5', M7:'UK6', M8:'UK7', M9:'UK8', M10:'UK9', M11:'UK10', M12:'UK11', M13:'UK12' },
    women: { W4:'UK1', W5:'UK2', W6:'UK3', W7:'UK4', W8:'UK5', W9:'UK6', W10:'UK7', W11:'UK8', W12:'UK9', W13:'UK10', W14:'UK11', W15:'UK12' }
  };

  // Build reverse maps: UK → Crocs
  const UK_TO_CROCS = { men: {}, women: {} };
  Object.entries(CROCS_TO_UK.men).forEach(([c, u]) => { UK_TO_CROCS.men[u] = c; });
  Object.entries(CROCS_TO_UK.women).forEach(([c, u]) => { UK_TO_CROCS.women[u] = c; });

  // Convert Crocs size → equivalent UK size
  function crocsToUK(size, category) {
    if (!size) return null;
    const s = size.toUpperCase().replace('/', '');
    // Handle unisex M5W7 → extract the relevant part
    const unisex = s.match(/^M(\d+)W(\d+)$/);
    if (unisex) {
      if (category === 'women') return CROCS_TO_UK.women[`W${unisex[2]}`] || null;
      return CROCS_TO_UK.men[`M${unisex[1]}`] || null;
    }
    return (CROCS_TO_UK[category] || {})[s] || null;
  }

  // Convert UK size → equivalent Crocs size
  function ukToCrocs(size, category) {
    if (!size) return null;
    return (UK_TO_CROCS[category] || {})[size.toUpperCase()] || null;
  }

  // Get the display-friendly equivalent label (e.g. "≈ UK7" or "≈ M8")
  function getCrossEquivalent(size, category) {
    if (!size) return '';
    if (isCrocsSize(size)) {
      const uk = crocsToUK(size, category);
      return uk ? `≈ ${uk}` : '';
    } else {
      const crocs = ukToCrocs(size, category);
      return crocs ? `≈ ${crocs}` : '';
    }
  }

  // Get gender from variant for non-Crocs products
  function getVariantGender(variant) {
    const g = (variant.gender || '').toLowerCase().trim();
    if (g === 'men' || g === 'male') return 'men';
    if (g === 'women' || g === 'female') return 'women';
    if (g === 'kids' || g === 'children' || g === 'youth' || g === 'junior') return 'kids';
    if (g === 'unisex-adult' || g === 'unisex') return 'men'; // default unisex to men
    return null;
  }

  // ===========================================
  // ===========================================
  // WHATSAPP BUTTON
  // ===========================================
  function updateWhatsAppPosition() {
    var wa = document.getElementById('bogo-whatsapp');
    var bar = document.getElementById('bogo-bottom-bar');
    if (!wa) return;
    if (bar && bar.style.display !== 'none') {
      // Hide WhatsApp when bottom bar is active — no overlap
      wa.style.display = 'none';
    } else {
      wa.style.display = 'flex';
      wa.style.bottom = '20px';
    }
  }

  // ===========================================
  // HISTORY PANEL
  // ===========================================
  function updateHistoryButton() {
    const btn = document.getElementById('bogo-history-btn');
    const count = document.getElementById('history-count');
    if (!btn) return;
    const len = state.recentlyViewed.length;
    if (len > 0) {
      btn.style.display = 'flex';
      if (count) count.textContent = len;
    } else {
      btn.style.display = 'none';
    }
  }

  function openHistoryPanel() {
    const panel = document.getElementById('bogo-history-panel');
    const list = document.getElementById('history-panel-list');
    if (!panel || !list) return;
    
    if (state.recentlyViewed.length === 0) {
      list.innerHTML = '<div style="padding:20px;text-align:center;color:#9ca3af;font-size:13px;">No products viewed yet</div>';
    } else {
      list.innerHTML = state.recentlyViewed.map(p => {
        const img = (p.images && p.images[0]);
        const discount = calcDiscount(p.price, p.comparePrice);
        return `
          <div class="bogo-history__item" data-product-id="${p.id}">
            <div class="bogo-history__img"><img src="${((img && img.src) || '')}" alt="${p.title}" loading="lazy"></div>
            <div class="bogo-history__info">
              <div class="bogo-history__type">${p.vendor || ''} · ${p.type || ''}</div>
              <div class="bogo-history__name">${cleanTitle(p.title)}</div>
              <div class="bogo-history__price">${formatPrice(p.price)} ${p.comparePrice > p.price ? '<s>' + formatPrice(p.comparePrice) + '</s>' : ''} ${discount > 0 ? '<span class="bogo-history__off">' + discount + '% OFF</span>' : ''}</div>
            </div>
            <svg class="bogo-history__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2.5" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
          </div>
        `;
      }).join('');
      // Click handling via delegation in bindEvents()
    }
    
    panel.style.display = 'block';
    requestAnimationFrame(() => panel.classList.add('bogo-history-panel--open'));
  }

  function closeHistoryPanel() {
    const panel = document.getElementById('bogo-history-panel');
    if (!panel) return;
    panel.classList.remove('bogo-history-panel--open');
    setTimeout(() => { panel.style.display = 'none'; }, 300);
  }

  // ===========================================
  // 3. STOCK URGENCY
  // ===========================================
  function getStockUrgency(product, size) {
    const matchingVariants = product.variants.filter(v => v.size === size && v.available);
    const hash = (product.id + size).split('').reduce((a, c) => a + c.charCodeAt(0), 0);
    const isLow = hash % 5 < 2;
    if (isLow && matchingVariants.length > 0) {
      const qty = (hash % 4) + 2;
      return qty;
    }
    return null;
  }

  // ===========================================
  // 4. SORT PRODUCTS
  // ===========================================
  // Fisher-Yates shuffle — seeded per visit so it stays consistent during browsing
  const shuffleSeed = Date.now();
  function seededRandom(i) {
    let x = Math.sin(shuffleSeed + i) * 10000;
    return x - Math.floor(x);
  }

  function shuffleProducts(arr) {
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(seededRandom(i) * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  function sortProducts(products) {
    const sorted = [...products];
    switch (state.sortOrder) {
      case 'price-asc':
        sorted.sort((a, b) => a.price - b.price);
        break;
      case 'price-desc':
        sorted.sort((a, b) => b.price - a.price);
        break;
      case 'newest':
        sorted.sort((a, b) => (b.id || 0) - (a.id || 0));
        break;
      default:
        // Default: price low to high
        sorted.sort((a, b) => a.price - b.price);
        return sorted;
    }
    return sorted;
  }

  // ===========================================
  // 5. AUTO-SCROLL TO PRODUCTS
  // ===========================================
  function scrollToProducts() {
    setTimeout(() => {
      const grid = document.getElementById('bogo-grid');
      const instructions = document.getElementById('bogo-instructions');
      const target = instructions || grid;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
  }

  // ===========================================
  // 6. PAIRS WELL WITH — Suggestions
  // ===========================================
  function renderSuggestions() {
    const container = document.getElementById('bogo-suggestions');
    if (!container) return;
    
    if (!state.bogoSelection.first || state.bogoSelection.second) {
      container.style.display = 'none';
      return;
    }
    
    const firstItem = state.bogoSelection.first;
    const size = state.selectedSizes[state.activeCategory];
    if (!size || size.length === 0) {
      container.style.display = 'none';
      return;
    }
    
    let suggestions = state.filteredProducts
      .filter(p => p.id !== firstItem.id)
      .sort((a, b) => ((b.images ? b.images.length : 0)) - ((a.images ? a.images.length : 0)))
      .slice(0, 6);
    
    if (suggestions.length === 0) {
      container.style.display = 'none';
      return;
    }
    
    container.style.display = 'block';
    const strip = document.getElementById('suggestions-strip');
    if (strip) {
      strip.innerHTML = suggestions.map(p => {
        const img = (p.images && p.images[0]);
        return `
          <div class="bogo-suggest__card" data-product-id="${p.id}">
            <div class="bogo-suggest__img-wrap">
              <img src="${((img && img.src) || '')}" alt="${p.title}" loading="lazy">
              <span class="bogo-suggest__free-tag">FREE</span>
            </div>
            <div class="bogo-suggest__name">${cleanTitle(p.title)}</div>
            <div class="bogo-suggest__price">${formatPrice(p.price)} <span>₹0</span></div>
          </div>
        `;
      }).join('');
      // Click handling via delegation in bindEvents()
    }
  }

  // ===========================================
  // 8. RECENTLY VIEWED
  // ===========================================
  function trackRecentlyViewed(product) {
    state.recentlyViewed = state.recentlyViewed.filter(p => p.id !== product.id);
    state.recentlyViewed.unshift(product);
    if (state.recentlyViewed.length > 10) state.recentlyViewed.pop();
    renderRecentlyViewed();
    updateHistoryButton();
  }
  
  function renderRecentlyViewed() {
    const container = document.getElementById('bogo-recently-viewed');
    if (!container) return;
    
    if (state.recentlyViewed.length < 2) {
      container.style.display = 'none';
      return;
    }
    
    container.style.display = 'block';
    const strip = document.getElementById('recently-viewed-strip');
    if (strip) {
      strip.innerHTML = state.recentlyViewed.map(p => {
        const img = (p.images && p.images[0]);
        return `
          <div class="bogo-recent__card" data-product-id="${p.id}">
            <img src="${((img && img.src) || '')}" alt="${p.title}" loading="lazy">
          </div>
        `;
      }).join('');
      // Click handling via delegation in bindEvents()
    }
  }

  // ===========================================
  // 11. COMPLETE THE DEAL NUDGE
  // ===========================================
  function startNudgeTimer() {
    clearNudgeTimer();
    if (state.bogoSelection.first && !state.bogoSelection.second) {
      state.nudgeTimer = setTimeout(() => {
        if (state.bogoSelection.first && !state.bogoSelection.second) {
          showToast("⏰ Don't forget your FREE pair! Pick any item — it's ₹0 🎁", 'info');
        }
      }, 30000);
    }
  }
  
  function clearNudgeTimer() {
    if (state.nudgeTimer) {
      clearTimeout(state.nudgeTimer);
      state.nudgeTimer = null;
    }
  }

  // ===========================================
  // API FETCHING — MULTI-COLLECTION
  // ===========================================
  async function fetchAllProducts() {
    if (state.isFetched || state.isLoading) {
      log('Already fetched or loading, skipping');
      return;
    }
    
    state.isLoading = true;
    state.fetchError = null;
    showLoading(true);
    
    const handles = state.collectionHandles;
    log('Fetching products from collections:', handles);
    
    if (!handles || handles.length === 0) {
      log('ERROR: No collection handles set!');
      state.fetchError = 'No collection selected';
      showError('No collection selected. Please configure in Theme Editor.');
      state.isLoading = false;
      showLoading(false);
      return;
    }

    try {
      // v4.2: Parallel fetch — all collections at once, render when ALL done
      async function fetchCollection(handle) {
        const products = [];
        let page = 1;
        let hasMore = true;

        while (hasMore) {
          const url = `/collections/${handle}/products.json?limit=${CONFIG.PRODUCTS_PER_PAGE}&page=${page}`;
          log('Fetching:', url);
          
          try {
            const response = await fetch(url);
            if (!response.ok) {
              log(`Warning: Collection ${handle} returned ${response.status}, skipping`);
              break;
            }
            
            const data = await response.json();
            const batch = data.products || [];
            
            log(`${handle} page ${page}: ${batch.length} products`);
            
            if (batch.length === 0) {
              hasMore = false;
            } else {
              products.push(...batch);
              page++;
              if (page > 20) {
                log('Safety limit reached (20 pages) for', handle);
                hasMore = false;
              }
            }
          } catch (fetchErr) {
            log(`Error fetching ${handle} page ${page}:`, fetchErr);
            break;
          }
        }
        log(`Collection ${handle} done: ${products.length} products`);
        return products;
      }

      // Fire all collections in parallel (Promise.all with safe wrapper)
      log('Starting parallel fetch for', handles.length, 'collections');
      const results = await Promise.all(
        handles.map(h => fetchCollection(h).catch(err => {
          log('Collection fetch failed for', h, ':', err);
          return []; // return empty array on failure
        }))
      );
      log('All collections fetched, merging...');

      // Merge + dedupe
      const allRaw = [];
      const seenIds = new Set();
      for (const collectionProducts of results) {
        for (const p of collectionProducts) {
          if (!seenIds.has(p.id)) {
            seenIds.add(p.id);
            allRaw.push(p);
          }
        }
      }

      log('Total unique products fetched:', allRaw.length);
      
      if (allRaw.length === 0) {
        showError('No products found in the selected collections.');
        state.isLoading = false;
        showLoading(false);
        return;
      }

      // Single render with everything ready
      state.allProducts = processProducts(allRaw);
      state.isFetched = true;
      
      log('Processed products:', state.allProducts.length);
      
      buildAvailableBrands();
      buildAvailableSizes();
      
      showLoading(false);
      updateUI();
      
    } catch (error) {
      console.error('BOGO Fetch Error:', error);
      state.fetchError = error.message;
      showError(`Failed to load products: ${error.message}`);
    } finally {
      state.isLoading = false;
      showLoading(false);
    }
  }

  function processProducts(products) {
    return products.map(p => {
      const variants = p.variants.map(v => ({
        id: v.id,
        title: v.title,
        size: v.option1 || v.title || 'One Size',
        gender: v.option2 || '',  // v4: capture gender from option2
        price: parseFloat(v.price) || 0,
        comparePrice: parseFloat(v.compare_at_price) || 0,
        available: v.available
      }));
      
      const availableVariants = variants.filter(v => v.available);
      const minPrice = availableVariants.length > 0 
        ? Math.min(...availableVariants.map(v => v.price))
        : Math.min(...variants.map(v => v.price));
      
      let productType = (p.product_type || '').trim();
      
      return {
        id: p.id,
        handle: p.handle,
        title: p.title,
        type: productType,
        vendor: p.vendor || '',
        tags: p.tags ? (Array.isArray(p.tags) ? p.tags : p.tags.split(',').map(t => t.trim())) : [],
        price: minPrice,
        comparePrice: Math.max(...variants.map(v => v.comparePrice || 0)),
        images: (p.images || []).map(i => ({
          src: i.src,
          thumb: i.src ? i.src.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_480x480.$1$2') : i.src
        })),
        variants: variants,
        available: variants.some(v => v.available)
      };
    }).filter(p => p.available && p.variants.some(v => v.size !== 'Default Title' && v.available));
  }

  // ===========================================
  // HELPERS
  // ===========================================

  // CROCS-ONLY: Does this Crocs size belong to this gender category?
  function sizeMatchesCrocsCategory(size, category) {
    if (!size) return false;
    const s = size.toUpperCase();
    
    if (category === 'kids') {
      return /^[CJ]\d/.test(s);
    }
    if (category === 'women') {
      return /^W\d/.test(s) || /^M\d+W\d+$/.test(s);
    }
    if (category === 'men') {
      return /^M\d/.test(s) || /^M\d+W\d+$/.test(s);
    }
    return false;
  }

  // v4: Does this product have variants matching the active gender category?
  function productMatchesCategory(product, category) {
    if (isCrocsBrand(product.vendor)) {
      return product.variants.some(v => v.available && sizeMatchesCrocsCategory(v.size, category));
    } else {
      // Non-Crocs: check variant gender field
      return product.variants.some(v => {
        if (!v.available) return false;
        const g = getVariantGender(v);
        return g === category;
      });
    }
  }

  // CROCS: Smart size matching (unisex aware)
  function getEquivalentSizes(size, category) {
    if (!size) return [size];
    const s = size.toUpperCase().replace('/', '');
    
    const unisex = s.match(/^M(\d+)W(\d+)$/);
    if (unisex) {
      const m = `M${unisex[1]}`;
      const w = `W${unisex[2]}`;
      const both = [`${m}W${unisex[2]}`, `${m}/W${unisex[2]}`];
      
      if (category === 'men') return [size, m, ...both];
      if (category === 'women') return [size, w, ...both];
      return [size, m, w, ...both];
    }
    
    const menMatch = s.match(/^M(\d+)$/);
    if (menMatch) {
      const menNum = parseInt(menMatch[1]);
      const womenNum = menNum + 2;
      return [size, `M${menNum}W${womenNum}`, `M${menNum}/W${womenNum}`];
    }
    
    const womenMatch = s.match(/^W(\d+)$/);
    if (womenMatch) {
      const womenNum = parseInt(womenMatch[1]);
      const menNum = womenNum - 2;
      if (menNum > 0) {
        return [size, `M${menNum}W${womenNum}`, `M${menNum}/W${womenNum}`];
      }
    }
    
    return [size];
  }

  // v4: Brand-aware size matching
  // v4.1: Brand-aware size matching with cross-brand equivalence
  function sizeMatches(variantSize, selectedSize, category, vendor) {
    if (!variantSize || !selectedSize) return false;
    if (variantSize === selectedSize) return true;
    
    if (isCrocsBrand(vendor)) {
      // ── CROCS PRODUCT ──
      if (isCrocsSize(selectedSize)) {
        const equivalents = getEquivalentSizes(selectedSize, category);
        return equivalents.some(eq => 
          eq.toUpperCase().replace('/', '') === variantSize.toUpperCase().replace('/', '')
        );
      }
      // Selected is UK format → convert UK to Crocs, then smart match
      const crocsEquiv = ukToCrocs(selectedSize, category);
      if (crocsEquiv) {
        const equivalents = getEquivalentSizes(crocsEquiv, category);
        return equivalents.some(eq => 
          eq.toUpperCase().replace('/', '') === variantSize.toUpperCase().replace('/', '')
        );
      }
      return false;
    }
    
    // ── NON-CROCS PRODUCT ──
    if (!isCrocsSize(selectedSize)) {
      return variantSize.toUpperCase() === selectedSize.toUpperCase();
    }
    // Selected is Crocs format → convert Crocs to UK, then exact match
    const ukEquiv = crocsToUK(selectedSize, category);
    if (ukEquiv) return variantSize.toUpperCase() === ukEquiv.toUpperCase();
    return false;
  }

  function formatSize(size) {
    if (!size) return '';
    const m = size.match(/^M(\d+)W(\d+)$/i);
    return m ? `M${m[1]}/W${m[2]}` : size;
  }

  // Kids size → age mapping (Crocs standard)
  const kidsAgeMap = {
    'C1': '<1 yr', 'C2': '<1 yr', 'C3': '<1 yr',
    'C4': '1-2 yr', 'C5': '1-2 yr', 'C6': '2 yr',
    'C7': '2-3 yr', 'C8': '3 yr', 'C9': '3-4 yr',
    'C10': '4 yr', 'C11': '4-5 yr', 'C12': '5 yr', 'C13': '5-6 yr',
    'J1': '6-7 yr', 'J2': '7-8 yr', 'J3': '8-9 yr',
    'J4': '9-10 yr', 'J5': '10-11 yr', 'J6': '11-12 yr'
  };

  function getKidsAge(size) {
    if (!size) return '';
    return kidsAgeMap[size.toUpperCase()] || '';
  }

  function formatPrice(price) {
    if (!price || price <= 0) return '₹0';
    return '₹' + Math.round(price).toLocaleString('en-IN');
  }

  function cleanTitle(title) {
    if (!title) return '';
    let cleaned = title
      .replace(/-/g, ' ')
      .replace(/\s+\d{4,}[\w]*$/i, '')
      .replace(/\b(CROCS)\b/i, 'Crocs')
      .replace(/\b(CLASSIC)\b/i, 'Classic')
      .replace(/\b(CLOG|SANDAL|FLIP|SLIDE|PLATFORM|LINED)\b/gi, (m) => m.charAt(0).toUpperCase() + m.slice(1).toLowerCase())
      .trim();
    return cleaned || title;
  }

  function calcDiscount(price, comparePrice) {
    if (!comparePrice || comparePrice <= price) return 0;
    return Math.round((1 - price / comparePrice) * 100);
  }

  // ── HIGH-CONVERSION CARD HELPERS ──
  // Deterministic hash from product ID for consistent pseudo-random values
  function _hashId(id) {
    var h = 0;
    var s = String(id);
    for (var i = 0; i < s.length; i++) {
      h = ((h << 5) - h + s.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
  }

  function getProductRating(product) {
    var h = _hashId(product.id);
    // Rating between 3.8 and 4.8
    var rating = 3.8 + (h % 11) / 10;
    // Review count: 80 - 2400 range
    var count = 80 + (h % 2321);
    var countLabel = count >= 1000 ? (Math.round(count / 100) / 10) + 'k' : String(count);
    return { rating: rating, count: count, countLabel: countLabel };
  }

  function getProductBoughtToday(product) {
    var h = _hashId(product.id + 7);
    return 5 + (h % 41); // 5 to 45
  }

  // Get available sizes for display on card (current category)
  function getCardSizes(product) {
    var cat = state.activeCategory;
    var seen = {};
    var sizes = [];
    product.variants.forEach(function(v) {
      if (!v.available || v.size === 'Default Title' || v.size === 'One Size') return;
      // Check if variant belongs to current category
      var belongs = false;
      if (isCrocsBrand(product.vendor)) {
        belongs = sizeMatchesCrocsCategory(v.size, cat);
      } else {
        belongs = getVariantGender(v) === cat;
      }
      if (belongs && !seen[v.size]) {
        seen[v.size] = true;
        sizes.push(formatSize(v.size));
      }
    });
    return sizes;
  }

  function showToast(message, type = 'info') {
    const toast = document.getElementById('bogo-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.className = `bogo-toast bogo-toast--visible bogo-toast--${type}`;
    setTimeout(() => toast.classList.remove('bogo-toast--visible'), 3000);
  }

  // ===========================================
  // LOADING STAGE PROGRESS
  // ===========================================
  var LOADING_STAGES = [
    { label: 'Finding your deals', icon: '🔍', pct: 15 },
    { label: 'Checking live stock', icon: '📦', pct: 45 },
    { label: 'Checking all sizes', icon: '👟', pct: 75 },
    { label: 'Almost ready!', icon: '✨', pct: 95 }
  ];
  var _loadingStageIdx = 0;
  var _loadingStageTimer = null;

  function startLoadingStages() {
    _loadingStageIdx = 0;
    _lUpdateStage();
    _loadingStageTimer = setInterval(function() {
      if (_loadingStageIdx < LOADING_STAGES.length - 1) {
        _loadingStageIdx++;
        _lUpdateStage();
      }
    }, 1800);
  }

  function stopLoadingStages() {
    if (_loadingStageTimer) { clearInterval(_loadingStageTimer); _loadingStageTimer = null; }
  }

  function _lUpdateStage() {
    var stage = LOADING_STAGES[_loadingStageIdx];
    var label = document.getElementById('loading-stage-label');
    var pct = document.getElementById('loading-stage-pct');
    var fill = document.getElementById('loading-stage-fill');
    if (label) label.textContent = stage.icon + ' ' + stage.label;
    if (pct) pct.textContent = stage.pct + '%';
    if (fill) fill.style.width = stage.pct + '%';
    var steps = document.querySelectorAll('#loading-stage-steps .bogo-loading__step');
    steps.forEach(function(step, i) {
      step.classList.remove('bogo-loading__step--active', 'bogo-loading__step--done');
      if (i < _loadingStageIdx) step.classList.add('bogo-loading__step--done');
      else if (i === _loadingStageIdx) step.classList.add('bogo-loading__step--active');
    });
  }

  function showLoading(show) {
    const loading = document.getElementById('bogo-loading');
    const grid = document.getElementById('bogo-grid');
    const empty = document.getElementById('bogo-empty-state');
    const noResults = document.getElementById('bogo-no-results');
    const error = document.getElementById('bogo-error-state');
    const sizeBtn = document.getElementById('size-selector-btn');
    const sizeText = document.getElementById('selected-size-text');
    
    if (show) {
      if (loading) loading.style.display = 'flex';
      if (grid) grid.style.display = 'none';
      if (empty) empty.style.display = 'none';
      if (noResults) noResults.style.display = 'none';
      if (error) error.style.display = 'none';
      if (sizeBtn) sizeBtn.classList.add('bogo-size-selector--disabled');
      if (sizeText) sizeText.textContent = '⏳ Loading...';
      startLoadingStages();
    } else {
      stopLoadingStages();
      if (loading) loading.style.display = 'none';
      if (sizeBtn) sizeBtn.classList.remove('bogo-size-selector--disabled');
      updateSizeButton();
    }
  }

  function showError(message) {
    const error = document.getElementById('bogo-error-state');
    const errorMsg = document.getElementById('bogo-error-message');
    const empty = document.getElementById('bogo-empty-state');
    const grid = document.getElementById('bogo-grid');
    
    if (error) {
      error.style.display = 'block';
      if (errorMsg) errorMsg.textContent = message;
    }
    if (empty) empty.style.display = 'none';
    if (grid) grid.style.display = 'none';
  }

  // ===========================================
  // BRAND MANAGEMENT (v4)
  // ===========================================
  function buildAvailableBrands() {
    var cat = state.activeCategory;
    var brandCounts = {};
    state.allProducts.forEach(function(p) {
      if (p.vendor && productMatchesCategory(p, cat)) {
        brandCounts[p.vendor] = (brandCounts[p.vendor] || 0) + 1;
      }
    });
    
    // Sort brands: Crocs first (if present), then alphabetical
    state.availableBrands = Object.keys(brandCounts).sort(function(a, b) {
      if (isCrocsBrand(a)) return -1;
      if (isCrocsBrand(b)) return 1;
      return a.localeCompare(b);
    });
    
    log('Available brands for', cat, ':', state.availableBrands, 'counts:', brandCounts);
    
    // If only one brand, auto-clear brand filter
    if (state.availableBrands.length <= 1) {
      state.selectedBrands = [];
    } else {
      // Remove any selected brands not available in this category
      state.selectedBrands = state.selectedBrands.filter(b => state.availableBrands.includes(b));
    }
    renderFilterPanel();
  }

  // ===========================================
  // FILTER PANEL — v5 (Option B)
  // ===========================================
  function renderFilterPanel() {
    renderBrandChips();
    renderTypeChips();
    renderSortChips();
    updateFilterBadge();
    renderActiveFilterTags();
  }

  function renderBrandChips() {
    const container = document.getElementById('filter-brand-chips');
    const section = document.getElementById('filter-brand-section');
    if (!container || !section) return;
    
    if (state.availableBrands.length <= 1) {
      section.style.display = 'none';
      return;
    }
    section.style.display = '';
    
    container.innerHTML = state.availableBrands.map(brand => {
      const isActive = state.selectedBrands.includes(brand);
      return `
        <button class="bogo-filter-chip ${isActive ? 'bogo-filter-chip--active' : ''}" 
                data-brand="${brand}">
          ${isActive ? '<span class="bogo-filter-chip__check">✓</span> ' : ''}${brand}
        </button>
      `;
    }).join('');
    // Click handling via delegation in bindEvents()
  }

  function renderTypeChips() {
    const container = document.getElementById('filter-type-chips');
    const section = document.getElementById('filter-type-section');
    if (!container || !section) return;
    
    const currentType = state.selectedTypes[state.activeCategory];
    const validTypes = state.availableTypes.filter(t => t && t.trim().length > 0);
    
    if (validTypes.length === 0) {
      section.style.display = 'none';
      return;
    }
    section.style.display = '';
    const types = ['All', ...validTypes];
    
    container.innerHTML = types.map(type => {
      const isActive = currentType === type;
      return `
        <button class="bogo-filter-chip ${isActive ? 'bogo-filter-chip--active' : ''}" 
                data-type="${type}">
          ${type}
        </button>
      `;
    }).join('');
    // Click handling via delegation in bindEvents()
  }

  function renderSortChips() {
    const container = document.getElementById('filter-sort-chips');
    if (!container) return;
    
    container.querySelectorAll('.bogo-filter-chip').forEach(chip => {
      const isActive = chip.dataset.sort === state.sortOrder;
      chip.classList.toggle('bogo-filter-chip--active', isActive);
    });
  }

  function toggleFilterPanel() {
    state.filterPanelOpen = !state.filterPanelOpen;
    const panel = document.getElementById('bogo-filter-panel');
    const btn = document.getElementById('filter-toggle-btn');
    if (panel) panel.style.display = state.filterPanelOpen ? '' : 'none';
    if (btn) btn.classList.toggle('bogo-filter-btn--active', state.filterPanelOpen);
    // Auto-scroll so full filter panel + Close Filters button is visible
    if (state.filterPanelOpen && panel) {
      setTimeout(function() {
        var closeBtn = document.getElementById('filter-panel-close');
        if (closeBtn) {
          closeBtn.scrollIntoView({ behavior: 'smooth', block: 'end' });
        } else {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 50);
    }
  }

  function getActiveFilterCount() {
    let count = 0;
    if (state.selectedBrands.length > 0) count += state.selectedBrands.length;
    if (state.selectedTypes[state.activeCategory] !== 'All') count += 1;
    if (state.sortOrder !== 'default') count += 1;
    return count;
  }

  function updateFilterBadge() {
    const badge = document.getElementById('filter-badge');
    if (!badge) return;
    const count = getActiveFilterCount();
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }

  function renderActiveFilterTags() {
    const wrapper = document.getElementById('bogo-filter-tags');
    const container = document.getElementById('filter-tags-container');
    if (!wrapper || !container) return;
    
    const tags = [];
    
    // Brand tags
    state.selectedBrands.forEach(brand => {
      tags.push({ label: brand, type: 'brand', value: brand });
    });
    
    // Type tag
    const currentType = state.selectedTypes[state.activeCategory];
    if (currentType !== 'All') {
      tags.push({ label: currentType, type: 'type', value: currentType });
    }
    
    // Sort tag
    if (state.sortOrder !== 'default') {
      const sortLabels = { 'price-asc': 'Low→High', 'price-desc': 'High→Low', 'newest': 'Newest' };
      tags.push({ label: sortLabels[state.sortOrder] || state.sortOrder, type: 'sort', value: state.sortOrder });
    }
    
    if (tags.length === 0) {
      wrapper.style.display = 'none';
      return;
    }
    
    wrapper.style.display = '';
    container.innerHTML = tags.map(tag => 
      `<button class="bogo-filter-tag" data-tag-type="${tag.type}" data-tag-value="${tag.value}">
        ${tag.label} <span class="bogo-filter-tag__x">✕</span>
      </button>`
    ).join('') + '<button class="bogo-filter-tags__clear" id="clear-all-filters">Clear all</button>';
    // Click handling via delegation in bindEvents()
  }

  // ===========================================
  // SIZE MANAGEMENT — BRAND-AWARE (v4)
  // ===========================================
  function buildAvailableSizes() {
    const brands = state.selectedBrands;
    const categorySizeMap = { men: {}, women: {}, kids: {} };
    
    state.allProducts.forEach(product => {
      // Brand filter — empty array means all brands
      if (brands.length > 0 && !brands.includes(product.vendor)) return;
      
      product.variants.forEach(variant => {
        if (!variant.available || !variant.size || variant.size === 'Default Title' || variant.size === 'One Size') return;
        
        if (isCrocsBrand(product.vendor)) {
          // ── CROCS: prefix-based gender + smart size extraction ──
          const size = variant.size;
          const s = size.toUpperCase().replace('/', '');
          
          if (sizeMatchesCrocsCategory(size, 'kids')) {
            if (!categorySizeMap.kids[size]) categorySizeMap.kids[size] = new Set();
            categorySizeMap.kids[size].add(product.id);
          }
          
          if (sizeMatchesCrocsCategory(size, 'men')) {
            const menKey = extractMenSize(s);
            if (menKey) {
              if (!categorySizeMap.men[menKey]) categorySizeMap.men[menKey] = new Set();
              categorySizeMap.men[menKey].add(product.id);
            }
          }
          
          if (sizeMatchesCrocsCategory(size, 'women')) {
            const womenKey = extractWomenSize(s);
            if (womenKey) {
              if (!categorySizeMap.women[womenKey]) categorySizeMap.women[womenKey] = new Set();
              categorySizeMap.women[womenKey].add(product.id);
            }
          }
        } else {
          // ── NON-CROCS: gender from option2, raw size as-is ──
          const gender = getVariantGender(variant);
          if (!gender) return;
          
          const size = variant.size; // UK7, UK8, etc. — show as-is
          if (!categorySizeMap[gender][size]) categorySizeMap[gender][size] = new Set();
          categorySizeMap[gender][size].add(product.id);
        }
      });
    });

    state.allSizes = { men: [], women: [], kids: [] };

    Object.entries(categorySizeMap.men).forEach(([size, ids]) => {
      state.allSizes.men.push({ size, count: ids.size });
    });
    Object.entries(categorySizeMap.women).forEach(([size, ids]) => {
      state.allSizes.women.push({ size, count: ids.size });
    });
    Object.entries(categorySizeMap.kids).forEach(([size, ids]) => {
      state.allSizes.kids.push({ size, count: ids.size });
    });

    // Sort: numeric extraction
    const sortFn = (a, b) => {
      const numA = parseFloat((a.size.match(/[\d.]+/) ? a.size.match(/[\d.]+/)[0] : 0));
      const numB = parseFloat((b.size.match(/[\d.]+/) ? b.size.match(/[\d.]+/)[0] : 0));
      if (numA !== numB) return numA - numB;
      return a.size.localeCompare(b.size);
    };
    
    Object.keys(state.allSizes).forEach(cat => {
      state.allSizes[cat].sort(sortFn);
    });
    
    log('Built sizes:', state.allSizes);
  }

  // Crocs: M5W7 → M5, M5 → M5
  function extractMenSize(s) {
    const unisex = s.match(/^M(\d+)W\d+$/);
    if (unisex) return `M${unisex[1]}`;
    const men = s.match(/^(M\d+)$/);
    if (men) return men[1];
    return null;
  }

  // Crocs: M5W7 → W7, W7 → W7
  function extractWomenSize(s) {
    const unisex = s.match(/^M\d+W(\d+)$/);
    if (unisex) return `W${unisex[1]}`;
    const women = s.match(/^(W\d+)$/);
    if (women) return women[1];
    return null;
  }

  function autoSelectFirstSize() {
    const categories = ['men', 'women', 'kids'];
    
    for (const cat of categories) {
      if (state.allSizes[cat].length > 0) {
        state.activeCategory = cat;
        state.selectedSizes[cat] = [state.allSizes[cat][0].size];
        log(`Auto-selected: ${cat} - ${state.selectedSizes[cat]}`);
        break;
      }
    }
  }

  // ===========================================
  // FILTERING — BRAND-AWARE (v4)
  // ===========================================
  function filterProducts() {
    const sizes = state.selectedSizes[state.activeCategory];
    const type = state.selectedTypes[state.activeCategory];
    const brands = state.selectedBrands;
    
    log('Filtering - Category:', state.activeCategory, 'Brands:', brands, 'Sizes:', sizes, 'Type:', type);
    
    if (!sizes || sizes.length === 0) {
      state.filteredProducts = [];
      state.availableTypes = [];
      log('No size selected, filtered products: 0');
      return;
    }

    let filtered = state.allProducts.filter(p => {
      // Brand filter — empty array means all brands
      if (brands.length > 0 && !brands.includes(p.vendor)) return false;
      
      return p.variants.some(v => {
        if (!v.available) return false;
        
        // Check against ANY of the selected sizes
        return sizes.some(size => {
          if (isCrocsBrand(p.vendor)) {
            if (!sizeMatchesCrocsCategory(v.size, state.activeCategory)) return false;
            return sizeMatches(v.size, size, state.activeCategory, p.vendor);
          } else {
            const g = getVariantGender(v);
            if (g !== state.activeCategory) return false;
            return sizeMatches(v.size, size, state.activeCategory, p.vendor);
          }
        });
      });
    });

    log('After size filter:', filtered.length);

    state.availableTypes = [...new Set(filtered.map(p => p.type))]
      .filter(t => t && typeof t === 'string' && t.trim().length > 0)
      .sort();
    log('Available types:', state.availableTypes);

    if (type !== 'All') {
      filtered = filtered.filter(p => p.type === type);
      log('After type filter:', filtered.length);
    }

    state.filteredProducts = sortProducts(filtered);
    log('Final filtered products:', state.filteredProducts.length);
  }

  // ===========================================
  // UI UPDATES
  // ===========================================
  function updateUI() {
    log('Updating UI...');
    filterProducts();
    updateTabs();
    renderFilterPanel();
    updateSizeButton();
    updateInstructions();
    updateProgress();
    updateBogoSlots();
    updateBottomBar();
    renderProducts();
    renderSuggestions();
    renderRecentlyViewed();
  }

  function updateTabs() {
    document.querySelectorAll('.bogo-tab').forEach(tab => {
      const cat = tab.dataset.category;
      const isActive = cat === state.activeCategory;
      const hasSizes = state.selectedSizes[cat] && state.selectedSizes[cat].length > 0;
      
      tab.classList.toggle('bogo-tab--active', isActive);
      
      const sizeEl = tab.querySelector('.bogo-tab__size');
      if (sizeEl) {
        if (hasSizes) {
          const arr = state.selectedSizes[cat];
          sizeEl.textContent = arr.length === 1 ? formatSize(arr[0]) : arr.length + ' sizes';
        } else {
          sizeEl.textContent = '';
        }
      }
      
      const countEl = tab.querySelector('.bogo-tab__count');
      if (countEl) {
        countEl.textContent = `(${(state.allSizes[cat] ? state.allSizes[cat].length : 0)})`;
      }
    });
  }

  // updateBrandPills — removed in v5, brands now in filter panel

  function updateSizeButton() {
    const btn = document.getElementById('size-selector-btn');
    const text = document.getElementById('selected-size-text');
    const sizes = state.selectedSizes[state.activeCategory];
    
    if (sizes && sizes.length > 0) {
      let displayText;
      if (sizes.length === 1) {
        // Show dual format: "M9 · UK8" or "UK8 · M9"
        var formatted = formatSize(sizes[0]);
        var equiv = getCrossEquivalent(sizes[0], state.activeCategory);
        displayText = equiv ? formatted + ' · ' + equiv.replace('≈ ', '') : formatted;
      } else if (sizes.length <= 3) {
        displayText = sizes.map(s => formatSize(s)).join(', ');
        if (displayText.length > 20) displayText = sizes.length + ' sizes selected';
      } else {
        displayText = sizes.length + ' sizes selected';
      }
      if (text) text.textContent = displayText;
      if (btn) {
        btn.classList.add('bogo-size-selector--selected');
        btn.classList.remove('bogo-size-selector--pulse');
      }
    } else {
      if (text) text.textContent = 'Select Size';
      if (btn) {
        btn.classList.remove('bogo-size-selector--selected');
        btn.classList.add('bogo-size-selector--pulse');
      }
    }
  }

  // updateTypePills — removed in v5, types now in filter panel

  function updateInstructions() {
    const step1 = document.getElementById('instruction-step1');
    const step2 = document.getElementById('instruction-step2');
    const size = state.selectedSizes[state.activeCategory];
    
    if (!step1 || !step2) return;
    
    if (!size || size.length === 0 || state.filteredProducts.length === 0) {
      step1.style.display = 'none';
      step2.style.display = 'none';
      return;
    }
    
    step1.style.display = !state.bogoSelection.first ? 'flex' : 'none';
    step2.style.display = state.bogoSelection.first && !state.bogoSelection.second ? 'flex' : 'none';
    
    if (state.cartPairs.length > 0 && !state.bogoSelection.first) {
      const totalInCart = state.cartPairs.length * 2;
      const title = step1.querySelector('.bogo-instruction__title');
      const sub = step1.querySelector('.bogo-instruction__subtitle');
      if (title) title.textContent = `Pair #${state.currentPairNum}: Tap any product`;
      if (sub) sub.textContent = `${totalInCart} items already in cart · Keep adding!`;
    }
  }

  function updateProgress() {
    const steps = document.querySelectorAll('.bogo-progress__step');
    const lines = document.querySelectorAll('.bogo-progress__line');
    
    let current = 1;
    if (state.bogoSelection.first && !state.bogoSelection.second) current = 2;
    if (state.bogoSelection.first && state.bogoSelection.second) current = 3;

    steps.forEach((step, i) => {
      const num = i + 1;
      const numEl = step.querySelector('.bogo-progress__number');
      
      step.classList.remove('bogo-progress__step--active', 'bogo-progress__step--complete');
      
      if (num < current) {
        step.classList.add('bogo-progress__step--complete');
        if (numEl) numEl.textContent = '✓';
      } else if (num === current) {
        step.classList.add('bogo-progress__step--active');
        if (numEl) numEl.textContent = num;
      } else {
        if (numEl) numEl.textContent = num;
      }
    });

    lines.forEach((line, i) => {
      line.classList.toggle('bogo-progress__line--active', i < current - 1);
    });
    
    if (state.cartPairs.length > 0) {
      const totalInCart = state.cartPairs.length * 2;
      const totalSaved = state.cartPairs.reduce((s, p) => s + p.savings, 0);
      const savingsEl = document.getElementById('bogo-savings');
      const savingsAmt = document.getElementById('bogo-savings-amount');
      if (savingsEl && !state.bogoSelection.first) {
        savingsEl.style.display = 'inline-block';
        if (savingsAmt) savingsAmt.textContent = `${totalInCart} items in cart · Save ${formatPrice(totalSaved)}`;
      }
    }
  }

  function updateBogoSlots() {
    updateBogoSlot('first', state.bogoSelection.first);
    updateBogoSlot('second', state.bogoSelection.second);
    
    const savings = document.getElementById('bogo-savings');
    const amt = document.getElementById('bogo-savings-amount');
    
    if (state.bogoSelection.first && state.bogoSelection.second) {
      const calc = calculateBogo();
      if (savings) savings.style.display = 'inline-block';
      if (amt) amt.textContent = formatPrice(calc.freeItem.price);
    } else {
      if (savings) savings.style.display = 'none';
    }
  }

  function updateBogoSlot(slot, item) {
    const el = document.getElementById(`bogo-slot-${slot}`);
    if (!el) return;
    
    const card = el.querySelector('.bogo-slot__card');
    const label = el.querySelector('.bogo-slot__label');
    
    if (item) {
      const img = getImgUrl(item);
      card.innerHTML = `
        <img src="${img}" alt="${item.title}" class="bogo-slot__image">
        <span class="bogo-slot__title">${item.title}</span>
        <span class="bogo-slot__size">${formatSize(item.selectedSize)}</span>
      `;
      card.classList.remove('bogo-slot__card--empty');
      card.classList.add('bogo-slot__card--filled', `bogo-slot__card--${slot}`);
      if (label) label.classList.add(slot === 'first' ? 'bogo-slot__label--active' : 'bogo-slot__label--free');
    } else {
      card.innerHTML = `
        <span class="bogo-slot__emoji">${slot === 'first' ? '👟' : '<svg width="38" height="38" viewBox="0 0 48 48" fill="none"><rect x="8" y="22" width="32" height="18" rx="3" fill="rgba(34,197,94,0.12)" stroke="rgba(34,197,94,0.5)" stroke-width="1.5"/><rect x="6" y="16" width="36" height="7" rx="2.5" fill="rgba(34,197,94,0.18)" stroke="rgba(34,197,94,0.5)" stroke-width="1.5"/><rect x="22" y="16" width="4" height="24" fill="rgba(34,197,94,0.25)"/><rect x="8" y="22" width="32" height="3.5" fill="rgba(34,197,94,0.2)"/><path d="M24 16c-3-5-9-5.5-9-2s7 4 9 2z" fill="rgba(34,197,94,0.35)" stroke="rgba(34,197,94,0.5)" stroke-width="1"/><path d="M24 16c3-5 9-5.5 9-2s-7 4-9 2z" fill="rgba(34,197,94,0.35)" stroke="rgba(34,197,94,0.5)" stroke-width="1"/><circle cx="24" cy="16" r="2" fill="rgba(34,197,94,0.5)"/></svg>'}</span>
        <span class="bogo-slot__text">${slot === 'first' ? 'Tap to Start ↓' : 'Pick Any!'}</span>
      `;
      card.classList.add('bogo-slot__card--empty');
      card.classList.remove('bogo-slot__card--filled', 'bogo-slot__card--first', 'bogo-slot__card--second');
      if (label) label.classList.remove('bogo-slot__label--active', 'bogo-slot__label--free');
    }
  }

  function updateBottomBar() {
    const bar = document.getElementById('bogo-bottom-bar');
    const spacer = document.getElementById('bottom-spacer');
    const partial = document.getElementById('bottom-bar-partial');
    const complete = document.getElementById('bottom-bar-complete');
    
    if (!bar) return;
    
    if (!state.bogoSelection.first) {
      bar.style.display = 'none';
      if (spacer) spacer.style.display = 'none';
      updateWhatsAppPosition();
      return;
    }

    bar.style.display = 'block';
    if (spacer) spacer.style.display = 'block';
    updateWhatsAppPosition();

    if (state.bogoSelection.second) {
      if (partial) partial.style.display = 'none';
      if (complete) complete.style.display = 'flex';
      
      var secureEl = document.getElementById('bar-secure');
      if (secureEl) secureEl.style.display = 'block';
      
      var calc = calculateBogo();
      var total = document.getElementById('bar-total');
      var original = document.getElementById('bar-original');
      var save = document.getElementById('bar-save');
      var sizes = document.getElementById('bar-sizes');
      var checkoutBtn = document.getElementById('checkout-btn');
      
      // v4.3: Populate pair thumbnails + make clickable
      var thumb1 = document.getElementById('complete-thumb-1');
      var thumb2 = document.getElementById('complete-thumb-2');
      var paidImg = getImgUrl(calc.paidItem);
      var freeImg = getImgUrl(calc.freeItem);
      if (thumb1) {
        thumb1.src = paidImg;
        thumb1.dataset.handle = calc.paidItem.handle || '';
      }
      if (thumb2) {
        thumb2.src = freeImg;
        thumb2.dataset.handle = calc.freeItem.handle || '';
      }
      
      if (total) total.textContent = formatPrice(calc.total);
      if (original) original.textContent = formatPrice(calc.total + calc.savings);
      if (save) save.textContent = 'SAVE ' + formatPrice(calc.savings);
      if (sizes) sizes.textContent = cleanTitle(calc.paidItem.title) + ' (' + formatSize(calc.paidItem.selectedSize) + ') + ' + cleanTitle(calc.freeItem.title) + ' (' + formatSize(calc.freeItem.selectedSize) + ') FREE';
      if (checkoutBtn) checkoutBtn.textContent = 'Add to Cart · ' + formatPrice(calc.total);
      
      if (state.cartPairs.length > 0) {
        var prevTotal = state.cartPairs.reduce(function(s, p) { return s + p.total; }, 0);
        var prevSavings = state.cartPairs.reduce(function(s, p) { return s + p.savings; }, 0);
        var grandTotal = prevTotal + calc.total;
        var grandSavings = prevSavings + calc.savings;
        var totalItems = (state.cartPairs.length + 1) * 2;
        if (sizes) sizes.textContent = 'Pair #' + state.currentPairNum + ' · Cart total: ' + formatPrice(grandTotal) + ' for ' + totalItems + ' items · Save ' + formatPrice(grandSavings);
      }
    } else {
      if (partial) partial.style.display = 'flex';
      if (complete) complete.style.display = 'none';
      
      const secureEl = document.getElementById('bar-secure');
      if (secureEl) secureEl.style.display = 'none';
      
      const partialThumb = document.getElementById('partial-thumb');
      const partialPrice = document.getElementById('partial-price');
      const first = state.bogoSelection.first;
      
      if (partialThumb && first.images && first.images[0]) {
        partialThumb.src = first.images[0].src || first.images[0].thumb || '';
        partialThumb.dataset.handle = first.handle || '';
        partialThumb.style.display = 'block';
      }
      if (partialPrice) partialPrice.textContent = formatPrice(first.price);
    }
  }

  // ===========================================
  // PRODUCT RENDERING
  // ===========================================
  function renderProducts() {
    const grid = document.getElementById('bogo-grid');
    const empty = document.getElementById('bogo-empty-state');
    const noResults = document.getElementById('bogo-no-results');
    const loadMore = document.getElementById('bogo-load-more');
    const allLoaded = document.getElementById('bogo-all-loaded');
    const error = document.getElementById('bogo-error-state');
    const size = state.selectedSizes[state.activeCategory];
    const hasSizes = size && size.length > 0;

    if (error) error.style.display = 'none';

    if (!hasSizes) {
      if (grid) grid.style.display = 'none';
      if (empty) empty.style.display = 'block';
      if (noResults) noResults.style.display = 'none';
      if (loadMore) loadMore.style.display = 'none';
      if (allLoaded) allLoaded.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';

    if (state.filteredProducts.length === 0) {
      if (grid) grid.style.display = 'none';
      if (noResults) noResults.style.display = 'block';
      if (loadMore) loadMore.style.display = 'none';
      if (allLoaded) allLoaded.style.display = 'none';
      return;
    }

    if (noResults) noResults.style.display = 'none';
    if (grid) grid.style.display = 'grid';

    if (state.displayedCount === 0) {
      state.displayedCount = Math.min(CONFIG.DISPLAY_PER_LOAD, state.filteredProducts.length);
    }

    const toShow = state.filteredProducts.slice(0, state.displayedCount);
    
    if (grid) {
      grid.innerHTML = toShow.map((p, i) => renderProductCard(p, i)).join('');
    }

    if (state.displayedCount < state.filteredProducts.length) {
      if (loadMore) loadMore.style.display = 'block';
      if (allLoaded) allLoaded.style.display = 'none';
    } else {
      if (loadMore) loadMore.style.display = 'none';
      if (allLoaded) {
        allLoaded.style.display = 'block';
      }
    }
  }

  function renderProductCard(p, idx) {
    const img = (p.images && p.images[0]);
    const noImgPlaceholder = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect fill='%23f3f4f6' width='200' height='200'/%3E%3Ctext x='100' y='105' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='sans-serif'%3ENo Image%3C/text%3E%3C/svg%3E";
    const imgSrc = (img && img.src) ? img.src : noImgPlaceholder;
    const imgLoading = (typeof idx === 'number' && idx < 4) ? 'eager' : 'lazy';
    const discount = calcDiscount(p.price, p.comparePrice);
    const imagesCount = (p.images ? p.images.length : 0);
    
    const isFirst = (state.bogoSelection.first && state.bogoSelection.first.id) === p.id;
    const isSecond = (state.bogoSelection.second && state.bogoSelection.second.id) === p.id;
    const isSelected = isFirst || isSecond;
    const showFree = state.bogoSelection.first && !state.bogoSelection.second && !isSelected;

    // ── Rating & social proof (deterministic) ──
    const ratingData = getProductRating(p);
    const boughtToday = getProductBoughtToday(p);
    const fullStars = Math.floor(ratingData.rating);
    const halfStar = (ratingData.rating - fullStars) >= 0.3;
    let starsHtml = '';
    for (var si = 0; si < 5; si++) {
      if (si < fullStars) starsHtml += '<span class="bogo-card__star bogo-card__star--full">★</span>';
      else if (si === fullStars && halfStar) starsHtml += '<span class="bogo-card__star bogo-card__star--half">★</span>';
      else starsHtml += '<span class="bogo-card__star">★</span>';
    }

    // ── Available sizes for card ──
    const cardSizes = getCardSizes(p);
    const maxShow = 2;
    const sizesToShow = cardSizes.slice(0, maxShow);
    const extraSizes = cardSizes.length - maxShow;
    let sizesStripHtml = '';
    if (sizesToShow.length > 0) {
      sizesStripHtml = '<div class="bogo-card__sizes-strip">';
      sizesToShow.forEach(function(s) {
        sizesStripHtml += '<span class="bogo-card__size-dot">' + s + '</span>';
      });
      if (extraSizes > 0) sizesStripHtml += '<span class="bogo-card__size-more">+' + extraSizes + '</span>';
      sizesStripHtml += '</div>';
    }

    // ── Brand label ──
    const brandLabel = p.vendor
      ? '<div class="bogo-card__brand">' + p.vendor + '</div>' : '';

    // ── Discount badge (top-left) ──
    let discountBadge = '';
    if (discount > 0) {
      discountBadge = '<div class="bogo-card__discount">' + discount + '% OFF</div>';
    }

    // ── Image count (camera icon, shown in info section) ──
    const imgCountHtml = imagesCount > 1
      ? '<span class="bogo-card__img-count"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg> ' + imagesCount + '</span>' : '';

    // ── Deselect button ──
    let deselectBtn = '';
    if (isFirst) deselectBtn = '<button class="bogo-card__deselect" data-deselect="first">✕</button>';
    else if (isSecond) deselectBtn = '<button class="bogo-card__deselect" data-deselect="second">✕</button>';

    // ── Build card based on state ──
    let cardClass = 'bogo-card';
    let topBadgeHtml = '';
    let priceHtml = '';
    let ctaHtml = '';
    let socialHtml = '';
    let savingsHtml = '';
    let ratingHtmlBlock = '';

    if (isFirst) {
      // ── SELECTED (1st pick) state ──
      cardClass += ' bogo-card--selected';
      topBadgeHtml = '<div class="bogo-card__selected-banner">✓ YOUR 1ST PICK</div>';
      const selectedSize = state.bogoSelection.first.size ? ' · Size: ' + formatSize(state.bogoSelection.first.size) : '';
      priceHtml = `
        <div class="bogo-card__prices">
          <span class="bogo-card__effective">${formatPrice(p.price)}</span>
          <span class="bogo-card__size-label">${selectedSize}</span>
        </div>`;
      ctaHtml = '<div class="bogo-card__cta-wrap"><button class="bogo-card__cta-btn bogo-card__cta-btn--selected">✓ Selected · PAY ' + formatPrice(p.price) + ' | Tap to remove</button></div>';

    } else if (isSecond) {
      // ── FREE ITEM (2nd pick) state ──
      cardClass += ' bogo-card--free-item';
      topBadgeHtml = '<div class="bogo-card__free-banner">🎁 YOUR FREE PAIR</div>';
      const selectedSize = state.bogoSelection.second.size ? ' · Size: ' + formatSize(state.bogoSelection.second.size) : '';
      priceHtml = `
        <div class="bogo-card__prices">
          <span class="bogo-card__compare-strike">${formatPrice(p.price)}</span>
          <span class="bogo-card__free-label">FREE</span>
          <span class="bogo-card__size-label">${selectedSize}</span>
        </div>`;
      ctaHtml = '<div class="bogo-card__cta-wrap"><button class="bogo-card__cta-btn bogo-card__cta-btn--free-selected">🎁 FREE! Tap to remove</button></div>';

    } else if (showFree) {
      // ── Available for FREE (step 2) state ──
      cardClass += ' bogo-card--free-available';
      topBadgeHtml = '<div class="bogo-card__bogo-tag bogo-card__bogo-tag--free">🎁 GET FREE</div>';
      ratingHtmlBlock = `
        <div class="bogo-card__rating">
          ${starsHtml}
          <span class="bogo-card__rating-num">${ratingData.rating.toFixed(1)}</span>
          <span class="bogo-card__rating-count">(${ratingData.countLabel})</span>
        </div>`;
      priceHtml = `
        <div class="bogo-card__prices">
          <span class="bogo-card__compare-strike">${formatPrice(p.price)}</span>
          <span class="bogo-card__free-label">FREE</span>
        </div>`;
      socialHtml = '<div class="bogo-card__social"><span class="bogo-card__social-dot"></span>' + boughtToday + ' bought today</div>';
      ctaHtml = '<div class="bogo-card__cta-wrap"><button class="bogo-card__cta-btn bogo-card__cta-btn--free">🎁 Get This Pair FREE →</button></div>';

    } else {
      // ── DEFAULT state ──
      topBadgeHtml = '<div class="bogo-card__bogo-tag">BUY 1 GET 1<br>FREE</div>';
      ratingHtmlBlock = `
        <div class="bogo-card__rating">
          ${starsHtml}
          <span class="bogo-card__rating-num">${ratingData.rating.toFixed(1)}</span>
          <span class="bogo-card__rating-count">(${ratingData.countLabel})</span>
        </div>`;
      priceHtml = `
        <div class="bogo-card__prices">
          <span class="bogo-card__effective">${formatPrice(p.price)} <small>/pair</small></span>
        </div>`;
      socialHtml = '<div class="bogo-card__social"><span class="bogo-card__social-dot"></span>' + boughtToday + ' bought today</div>';
      savingsHtml = '<div class="bogo-card__savings-line">🎁 Add any 2 pairs — pay only for the higher-priced one<span>You save ' + formatPrice(p.price) + ' on the 2nd pair</span></div>';
      ctaHtml = '<div class="bogo-card__cta-wrap"><button class="bogo-card__cta-btn bogo-card__cta-btn--primary">View &amp; Select This Pair →</button></div>';
    }

    // ── Exchange trust line ──
    const exchangeHtml = '<div class="bogo-card__exchange"><svg viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg><span>7 Days Easy Exchange · 100% Original</span></div>';

    return `
      <div class="${cardClass}" data-product-id="${p.id}">
        ${deselectBtn}
        ${isFirst ? topBadgeHtml : ''}
        ${isSecond ? topBadgeHtml : ''}
        <div class="bogo-card__image">
          <img src="${imgSrc}" alt="${p.title}" class="bogo-card__img" loading="${imgLoading}" onerror="this.onerror=null;this.style.objectFit='contain';this.src=this.dataset.placeholder" data-placeholder="${noImgPlaceholder}">
          ${discountBadge}
          ${(!isFirst && !isSecond) ? topBadgeHtml : ''}
        </div>
        ${(!isSelected) ? sizesStripHtml : ''}
        <div class="bogo-card__info">
          <div class="bogo-card__brand-row">
            ${brandLabel}
            ${imgCountHtml}
          </div>
          <h3 class="bogo-card__title">${cleanTitle(p.title)}</h3>
          ${ratingHtmlBlock}
          ${priceHtml}
          ${socialHtml}
          ${savingsHtml}
        </div>
        ${ctaHtml}
        ${exchangeHtml}
      </div>
    `;
  }

  function loadMoreProducts() {
    state.displayedCount = Math.min(
      state.displayedCount + CONFIG.DISPLAY_PER_LOAD,
      state.filteredProducts.length
    );
    renderProducts();
  }

  // ===========================================
  // SIZE MODAL — BRAND-AWARE (v4)
  // ===========================================
  function openSizeModal() {
    // Block size selection while products are still loading
    if (state.isLoading || !state.isFetched) {
      showToast('⏳ Products are loading, please wait...', 'info');
      return;
    }

    const modal = document.getElementById('size-modal');
    const body = document.getElementById('size-modal-body');
    const icon = document.getElementById('size-modal-icon');
    const catText = document.getElementById('size-modal-category');
    
    if (!modal || !body) return;
    
    const cat = state.activeCategory;
    const sizes = state.allSizes[cat];
    const current = state.selectedSizes[cat];
    const brands = state.selectedBrands;

    // v4.3 Style H icons for size modal
    if (icon) icon.innerHTML = styleHIcon(28, cat === 'men' ? 'M' : cat === 'women' ? 'W' : 'K', cat === 'kids', true);
    var labels = { men: "Men's", women: "Women's", kids: "Kids'" };
    if (catText) catText.textContent = labels[cat];

    if (sizes.length === 0) {
      body.innerHTML = '<div class="bogo-modal__empty">No sizes available for this category. Try another tab or brand.</div>';
    } else {
      let html = `<div style="text-align:right; margin-bottom:10px;">
        <button type="button" class="size-modal-chart-link" style="background:none; border:none; color:var(--bogo-primary); font-size:12px; font-weight:600; cursor:pointer; padding:4px 0; display:inline-flex; align-items:center; gap:4px;">📏 Size Chart →</button>
      </div>`;
      
      // Determine which size system to render
      const hasCrocsSizes = sizes.some(s => isCrocsSize(s.size));
      const hasUKSizes = sizes.some(s => {
        const up = s.size.replace(/\s+/g, '').toUpperCase();
        return up.startsWith('UK') || up.endsWith('UK');
      });
      
      if (hasCrocsSizes && !hasUKSizes) {
        // Pure Crocs: existing grouped layout
        html += renderCrocsSizeGroups(cat, sizes, current);
      } else if (hasUKSizes && !hasCrocsSizes) {
        // Pure UK: simple grid
        html += renderUKSizeGrid(sizes, current);
      } else {
        // Mixed (brand = All): unify Crocs + UK into one grid by UK equivalent
        html += renderUnifiedSizeGrid(cat, sizes, current);
      }
      
      body.innerHTML = html;
      
      body.querySelectorAll('.bogo-size-btn').forEach(btn => {
        btn.addEventListener('click', () => selectSize(btn.dataset.size));
      });
      
      // Bind in-body size chart links
      body.querySelectorAll('.size-modal-chart-link').forEach(btn => {
        btn.addEventListener('click', () => {
          closeSizeModal();
          openSizeChart();
        });
      });
    }

    modal.style.display = 'flex';
    lockScroll();
    updateSizeModalDoneButton();
  }

  // Render Crocs-style size groups (Unisex, Men's Only, Kids C/J sections)
  function renderCrocsSizeGroups(cat, sizes, current) {
    let html = '';
    
    if (cat === 'kids') {
      const cSizes = sizes.filter(s => s.size.toUpperCase().startsWith('C'));
      const jSizes = sizes.filter(s => s.size.toUpperCase().startsWith('J'));
      
      if (cSizes.length) {
        html += `<div class="bogo-modal__section">
          <div class="bogo-modal__section-title">👶 Toddler & Little Kids · <span style="color:var(--bogo-primary);font-weight:600">Age <1 to 6 yr</span></div>
          <div class="bogo-modal__sizes">${cSizes.map(s => renderSizeButton(s, current)).join('')}</div>
        </div>`;
      }
      if (jSizes.length) {
        html += `<div class="bogo-modal__section">
          <div class="bogo-modal__section-title">🧒 Junior / Big Kids · <span style="color:var(--bogo-primary);font-weight:600">Age 6-12 yr</span></div>
          <div class="bogo-modal__sizes">${jSizes.map(s => renderSizeButton(s, current)).join('')}</div>
        </div>`;
      }
    } else {
      const unisex = sizes.filter(s => /^M\d+W\d+$/i.test(s.size));
      const specific = cat === 'men' 
        ? sizes.filter(s => /^M\d+$/i.test(s.size))
        : sizes.filter(s => /^W\d+$/i.test(s.size));
      
      if (unisex.length) {
        html += `<div class="bogo-modal__section">
          <div class="bogo-modal__section-title">Unisex Sizes</div>
          <div class="bogo-modal__sizes bogo-modal__sizes--unisex">${unisex.map(s => renderSizeButton(s, current)).join('')}</div>
        </div>`;
      }
      if (specific.length) {
        const label = cat === 'men' ? "Men's Only" : "Women's Only";
        html += `<div class="bogo-modal__section">
          <div class="bogo-modal__section-title">${label}</div>
          <div class="bogo-modal__sizes">${specific.map(s => renderSizeButton(s, current)).join('')}</div>
        </div>`;
      }
    }
    
    return html;
  }

  // Render flat UK size grid (non-Crocs brands)
  function renderUKSizeGrid(sizes, current) {
    return `<div class="bogo-modal__section">
      <div class="bogo-modal__sizes">${sizes.map(s => renderSizeButton(s, current)).join('')}</div>
    </div>`;
  }

  // Render unified size grid: clubs Crocs + UK sizes together by UK equivalent
  // Shows Crocs size (W7/M8) as primary, ≈ UK below, combined item count
  function renderUnifiedSizeGrid(cat, sizes, current) {
    const crocsSizes = sizes.filter(s => isCrocsSize(s.size));
    const ukSizes = sizes.filter(s => !isCrocsSize(s.size));

    // Normalize messy UK formats ("4UK", "UK 3", "uk4") → "UK4"
    function normalizeUK(raw) {
      const s = raw.replace(/\s+/g, '').toUpperCase();
      // "4UK" → "UK4", "5UK" → "UK5"
      const suffixed = s.match(/^([\d.]+)UK$/);
      if (suffixed) return 'UK' + suffixed[1];
      // "UK4" → "UK4"
      const prefixed = s.match(/^UK([\d.]+)$/);
      if (prefixed) return 'UK' + prefixed[1];
      return s;
    }

    // Build a map keyed by UK size → { crocsSize, ukLabel, count, selectSize }
    const unified = {};
    const orphanCrocs = []; // Crocs sizes with no UK mapping
    const orphanUK = [];    // UK sizes with no Crocs mapping

    // Process Crocs sizes first
    crocsSizes.forEach(s => {
      const ukEquiv = crocsToUK(s.size, cat);
      if (ukEquiv) {
        const key = ukEquiv.toUpperCase();
        if (!unified[key]) unified[key] = { crocsSize: s.size, ukLabel: ukEquiv, count: 0, selectSize: s.size };
        unified[key].count += s.count;
        // Prefer the Crocs size for selection (cross-matching handles non-Crocs products)
        unified[key].crocsSize = s.size;
      } else {
        orphanCrocs.push(s);
      }
    });

    // Process UK sizes — merge into existing entries or create new
    ukSizes.forEach(s => {
      const norm = normalizeUK(s.size);
      const key = norm.toUpperCase();
      if (unified[key]) {
        // Already has a Crocs equivalent — add count
        unified[key].count += s.count;
      } else {
        // No Crocs equivalent exists — try reverse lookup for display
        const crocsEquiv = ukToCrocs(norm, cat);
        if (crocsEquiv) {
          unified[key] = { crocsSize: crocsEquiv, ukLabel: norm, count: s.count, selectSize: crocsEquiv };
        } else {
          orphanUK.push({ ...s, ukLabel: norm });
        }
      }
    });

    // Sort unified entries by UK numeric value
    const sortedEntries = Object.values(unified).sort((a, b) => {
      const numA = parseFloat((a.ukLabel.match(/[\d.]+/) || ['0'])[0]);
      const numB = parseFloat((b.ukLabel.match(/[\d.]+/) || ['0'])[0]);
      return numA - numB;
    });

    let html = '';

    if (sortedEntries.length > 0) {
      // Build unified buttons
      const selectedArr = Array.isArray(current) ? current : (current ? [current] : []);
      const buttons = sortedEntries.map(entry => {
        const isSelected = selectedArr.includes(entry.selectSize) || selectedArr.some(s => s.toUpperCase() === entry.ukLabel.toUpperCase());
        return `
          <button class="bogo-size-btn ${isSelected ? 'bogo-size-btn--selected' : ''}" data-size="${entry.selectSize}">
            <span class="bogo-size-btn__size">${formatSize(entry.crocsSize)}</span>
            <span class="bogo-size-btn__equiv">≈ ${entry.ukLabel}</span>
          </button>
        `;
      }).join('');

      html += `<div class="bogo-modal__section">
        <div class="bogo-modal__sizes">${buttons}</div>
      </div>`;
    }

    // Orphan Crocs (no UK equivalent — rare)
    if (orphanCrocs.length > 0) {
      html += `<div class="bogo-modal__section">
        <div class="bogo-modal__sizes">${orphanCrocs.map(s => renderSizeButton(s, current)).join('')}</div>
      </div>`;
    }

    // Orphan UK (no Crocs equivalent — rare edge cases)
    if (orphanUK.length > 0) {
      html += `<div class="bogo-modal__section" style="margin-top:12px;">
        <div class="bogo-modal__section-title">Other UK Sizes</div>
        <div class="bogo-modal__sizes">${orphanUK.map(s => renderSizeButton(s, current)).join('')}</div>
      </div>`;
    }

    return html;
  }

  function renderSizeButton(sizeData, current) {
    const isSelected = Array.isArray(current) ? current.includes(sizeData.size) : sizeData.size === current;
    const age = getKidsAge(sizeData.size);
    const ageHtml = age ? `<span class="bogo-size-btn__age">${age}</span>` : '';
    // v4.1: Show equivalent from other size system when brand=All
    const equiv = state.selectedBrands.length === 0 ? getCrossEquivalent(sizeData.size, state.activeCategory) : '';
    const equivHtml = equiv ? `<span class="bogo-size-btn__equiv">${equiv}</span>` : '';
    return `
      <button class="bogo-size-btn ${isSelected ? 'bogo-size-btn--selected' : ''}" data-size="${sizeData.size}">
        <span class="bogo-size-btn__size">${formatSize(sizeData.size)}</span>
        ${equivHtml}
        ${ageHtml}
      </button>
    `;
  }

  function closeSizeModal() {
    const modal = document.getElementById('size-modal');
    if (modal && modal.style.display !== 'none') {
      modal.style.display = 'none';
      unlockScroll();
    }
  }

  function selectSize(size) {
    log('=== SIZE SELECTED ===', size, 'Category:', state.activeCategory);
    const cat = state.activeCategory;
    const arr = state.selectedSizes[cat];
    const idx = arr.indexOf(size);
    if (idx >= 0) {
      arr.splice(idx, 1); // deselect
    } else {
      arr.push(size); // add
    }
    state.selectedTypes[cat] = 'All';
    state.displayedCount = 0;
    // Don't close modal — let user pick multiple sizes
    log('State after selection:', JSON.stringify(state.selectedSizes));
    updateUI();
    log('=== UI UPDATED after size select ===');
    log('Filtered products:', state.filteredProducts.length);
    // Re-render size modal buttons to reflect multi-select state
    refreshSizeModalButtons();
    updateSizeModalDoneButton();
  }

  // Update the "Show Products" footer button state
  function updateSizeModalDoneButton() {
    var doneBtn = document.getElementById('size-modal-done-btn');
    if (!doneBtn) return;
    var sizes = state.selectedSizes[state.activeCategory];
    if (!sizes || sizes.length === 0) {
      doneBtn.textContent = 'Pick a size to continue';
      doneBtn.style.opacity = '0.5';
      doneBtn.style.pointerEvents = 'none';
      doneBtn.classList.remove('bogo-modal__footer-btn--active');
    } else {
      doneBtn.textContent = 'Show Products →';
      doneBtn.style.opacity = '1';
      doneBtn.style.pointerEvents = 'auto';
      doneBtn.style.background = 'linear-gradient(135deg, #f97316, #ea580c)';
      doneBtn.classList.remove('bogo-modal__footer-btn--active');
      void doneBtn.offsetWidth;
      doneBtn.classList.add('bogo-modal__footer-btn--active');
    }
  }

  // Refresh size modal button states without re-opening
  function refreshSizeModalButtons() {
    const body = document.getElementById('size-modal-body');
    if (!body) return;
    const cat = state.activeCategory;
    const selected = state.selectedSizes[cat];
    body.querySelectorAll('.bogo-size-btn').forEach(btn => {
      const isSelected = selected.includes(btn.dataset.size);
      btn.classList.toggle('bogo-size-btn--selected', isSelected);
    });
  }

  // ===========================================
  // CATEGORY TABS
  // ===========================================
  function switchCategory(cat) {
    log('Switching category to:', cat);
    state.activeCategory = cat;
    state.displayedCount = 0;
    
    // v4.3 Style H: Update tab icons — active = filled navy, inactive = outlined
    document.querySelectorAll('.bogo-tab').forEach(function(t) {
      var isActive = t.dataset.category === cat;
      t.classList.toggle('bogo-tab--active', isActive);
      var iconEl = t.querySelector('.bogo-tab__icon');
      if (iconEl) {
        var letter = t.dataset.category === 'men' ? 'M' : t.dataset.category === 'women' ? 'W' : 'K';
        var star = t.dataset.category === 'kids';
        iconEl.innerHTML = styleHIcon(42, letter, star, isActive);
      }
    });

    // Style H for empty state icon (larger)
    var emptyIcon = document.getElementById('empty-state-icon');
    var emptyLetter = cat === 'men' ? 'M' : cat === 'women' ? 'W' : 'K';
    var emptyStar = cat === 'kids';
    if (emptyIcon) emptyIcon.innerHTML = styleHIcon(56, emptyLetter, emptyStar, true);

    // Rebuild sizes for new category (brand counts may change)
    buildAvailableSizes();
    // v4.3: Rebuild brand pills filtered by active category
    buildAvailableBrands();
    
    updateUI();
  }

  // ===========================================
  // QUICK VIEW
  // ===========================================
  function openQuickView(product) {
    log('Opening quick view for:', product.title, '(vendor:', product.vendor, ')');
    state.quickViewProduct = product;
    state.quickViewImageIndex = 0;
    state._savedScrollY = window.scrollY; // Save scroll position for restoration
    
    trackRecentlyViewed(product);
    
    const currentSizes = state.selectedSizes[state.activeCategory];
    const currentSize = currentSizes && currentSizes.length > 0 ? currentSizes[0] : null;
    const availableVariant = product.variants.find(v => {
      if (!v.available) return false;
      return sizeMatches(v.size, currentSize, state.activeCategory, product.vendor);
    });
    state.quickViewSelectedSize = availableVariant 
      ? availableVariant.size 
      : (function(){ var f = product.variants.find(function(v){return v.available}); return f ? f.size : null; })();

    renderQuickView();
    
    const modal = document.getElementById('quickview-modal');
    if (modal) {
      modal.style.display = 'flex';
      lockScroll();
    }
  }

  function renderQuickView() {
    const p = state.quickViewProduct;
    if (!p) return;

    const inFreePickStage = state.bogoSelection.first && !state.bogoSelection.second;
    const isViewingFirstItem = state.bogoSelection.first && p.id === state.bogoSelection.first.id;
    const isFree = inFreePickStage && !isViewingFirstItem;
    
    const discount = calcDiscount(p.price, p.comparePrice);

    const status = document.getElementById('quickview-status');
    if (status) {
      status.style.display = 'block';
      if (!state.bogoSelection.first) {
        status.textContent = 'Select 1st Item';
        status.style.background = '#ede9f5';
        status.style.color = '#312e81';
      } else if (!state.bogoSelection.second) {
        status.textContent = '🎁 This is FREE!';
        status.style.background = '#dcfce7';
        status.style.color = '#166534';
      } else {
        status.textContent = '🔄 Swap with existing pick';
        status.style.background = '#fff7ed';
        status.style.color = '#c2410c';
      }
    }

    renderQuickViewGallery();

    const typeEl = document.getElementById('quickview-type');
    const titleEl = document.getElementById('quickview-title');
    // v4: Show brand + type
    if (typeEl) typeEl.textContent = (p.vendor ? p.vendor + ' · ' : '') + (p.type || '');
    if (titleEl) titleEl.textContent = cleanTitle(p.title);

    const pricingEl = document.getElementById('quickview-pricing');
    if (pricingEl) {
      if (isFree) {
        pricingEl.innerHTML = `
          <span style="font-size:28px; font-weight:800; color:#22c55e;">FREE</span>
          <span style="font-size:18px; color:#9ca3af; text-decoration:line-through;">${formatPrice(p.price)}</span>
        `;
      } else {
        var qvDiscount = calcDiscount(p.price, p.comparePrice);
        var discountHtml = qvDiscount > 0 ? '<span style="font-size:13px; font-weight:700; color:#dc2626; background:#fef2f2; padding:2px 8px; border-radius:4px;">' + qvDiscount + '% OFF</span>' : '';
        pricingEl.innerHTML = `
          <div style="display:flex; flex-direction:column; gap:4px;">
            <div style="display:flex; align-items:baseline; gap:8px;">
              <span style="font-size:24px; font-weight:800; color:#1f2937;">MRP ${formatPrice(p.price)}</span>
              ${discountHtml}
            </div>
            <span style="font-size:13px; font-weight:600; color:#16a34a;">Buy 1 &amp; get 2nd pair FREE · You save ${formatPrice(p.price)}</span>
          </div>
        `;
      }
    }

    const availableVariants = p.variants.filter(v => v.available);
    const sizeCountEl = document.getElementById('quickview-size-count');
    if (sizeCountEl) sizeCountEl.textContent = `(${availableVariants.length} available)`;

    const grid = document.getElementById('quickview-sizes');
    const filterSizes = state.selectedSizes[state.activeCategory] || [];
    
    if (grid) {
      grid.innerHTML = availableVariants.map(v => {
        if (v.size === 'Default Title' || v.size === 'One Size') return '';
        const isSelected = v.size === state.quickViewSelectedSize;
        const isFilterMatch = filterSizes.some(fs => sizeMatches(v.size, fs, state.activeCategory, p.vendor)) && !isSelected;
        const bgColor = isSelected ? '#f97316' : (isFilterMatch ? 'rgba(212,133,31,0.15)' : '#fff');
        const borderColor = isSelected ? '#f97316' : (isFilterMatch ? '#d4851f' : '#e5e7eb');
        const textColor = isSelected ? '#fff' : '#374151';
        const age = getKidsAge(v.size);
        const ageLabel = age ? `<div style="font-size:10px;font-weight:500;opacity:0.7;margin-top:2px;">${age}</div>` : '';
        const urgency = getStockUrgency(p, v.size);
        const urgencyLabel = urgency ? `<div style="font-size:9px;font-weight:700;color:${isSelected ? 'rgba(255,255,255,0.85)' : '#ef4444'};margin-top:2px;">Only ${urgency} left</div>` : '';
        return `
          <button type="button" data-size="${v.size}" data-variant-id="${v.id}" style="padding:14px 8px; background:${bgColor}; border:2px solid ${borderColor}; border-radius:10px; font-size:14px; font-weight:600; color:${textColor}; cursor:pointer; text-align:center;">
            ${formatSize(v.size)}${ageLabel}${urgencyLabel}
          </button>
        `;
      }).join('');

      grid.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
          state.quickViewSelectedSize = btn.dataset.size;
          updateQuickViewSizesUI();
          updateQuickViewCTA();
        });
      });
    }

    updateQuickViewCTA();
  }

  function updateQuickViewSizesUI() {
    const grid = document.getElementById('quickview-sizes');
    const p = state.quickViewProduct;
    if (!grid || !p) return;
    const filterSizes = state.selectedSizes[state.activeCategory] || [];
    
    grid.querySelectorAll('button').forEach(btn => {
      const isSelected = btn.dataset.size === state.quickViewSelectedSize;
      const isFilterMatch = filterSizes.some(fs => sizeMatches(btn.dataset.size, fs, state.activeCategory, p.vendor)) && !isSelected;
      btn.style.background = isSelected ? '#f97316' : (isFilterMatch ? 'rgba(212,133,31,0.15)' : '#fff');
      btn.style.borderColor = isSelected ? '#f97316' : (isFilterMatch ? '#d4851f' : '#e5e7eb');
      btn.style.color = isSelected ? '#fff' : '#374151';
    });
  }

  function updateQuickViewCTA() {
    const p = state.quickViewProduct;
    if (!p) return;
    
    const addBtn = document.getElementById('quickview-add-btn');
    if (!addBtn) return;
    
    addBtn.disabled = !state.quickViewSelectedSize;

    if (!state.quickViewSelectedSize) {
      addBtn.textContent = 'Select a size above';
      addBtn.style.background = '#d1d5db';
      addBtn.style.color = '#9ca3af';
      addBtn.style.cursor = 'not-allowed';
    } else if (!state.bogoSelection.first) {
      addBtn.innerHTML = `✓ Select This (${formatSize(state.quickViewSelectedSize)}) · Pick FREE Next →`;
      addBtn.style.background = '#1e1b4b';
      addBtn.style.color = '#fff';
      addBtn.style.cursor = 'pointer';
    } else if (!state.bogoSelection.second) {
      addBtn.innerHTML = `🎁 Get This FREE · ₹0 (${formatSize(state.quickViewSelectedSize)})`;
      addBtn.style.background = 'linear-gradient(135deg, #22c55e, #16a34a)';
      addBtn.style.color = '#fff';
      addBtn.style.cursor = 'pointer';
    } else {
      addBtn.innerHTML = `🔄 Replace an Item (${formatSize(state.quickViewSelectedSize)})`;
      addBtn.style.background = '#1e1b4b';
      addBtn.style.color = '#fff';
      addBtn.style.cursor = 'pointer';
    }
    
    const micro = document.getElementById('quickview-micro');
    if (micro) {
      if (state.bogoSelection.first && !state.bogoSelection.second) {
        micro.innerHTML = '🎁 This item will be ₹0 in your cart · You pay only for your first pick';
        micro.style.color = '#166534';
      } else {
        micro.innerHTML = '📦 Delivery in 5-7 days · 100% Original with GST Bill';
        micro.style.color = '#9ca3af';
      }
    }
  }

  function renderQuickViewGallery() {
    const p = state.quickViewProduct;
    if (!p) return;
    
    const images = p.images || [];
    const idx = state.quickViewImageIndex;

    const container = document.getElementById('quickview-images');
    if (container) {
      container.innerHTML = images.map((img, i) => `
        <div style="flex:0 0 100%; display:flex; align-items:center; justify-content:center; padding:16px; min-height:260px;">
          <img src="${img.src}" alt="${p.title}" data-index="${i}" loading="${i < 2 ? 'eager' : 'lazy'}" style="max-width:100%; max-height:280px; width:auto; height:auto; object-fit:contain; display:block;">
        </div>
      `).join('');
      container.style.transform = `translateX(-${idx * 100}%)`;
      container.style.transition = 'transform 0.3s ease';

      container.querySelectorAll('img').forEach(img => {
        img.addEventListener('click', () => {
          // Tap image = show next image (cycle), not zoom
          const totalImages = images.length;
          if (totalImages <= 1) return;
          state.quickViewImageIndex = (state.quickViewImageIndex + 1) % totalImages;
          renderQuickViewGallery();
        });
      });
      
      // Attach touch listeners ONCE per container element (prevents accumulation)
      if (!container._bogoTouchBound) {
        container._bogoTouchBound = true;
        let touchStartX = 0, touchStartY = 0;
        container.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY; }, { passive: true });
        container.addEventListener('touchmove', (e) => {
          const dx = Math.abs(e.touches[0].clientX - touchStartX);
          const dy = Math.abs(e.touches[0].clientY - touchStartY);
          if (dx > dy && dx > 10) e.preventDefault();
        }, { passive: false });
        container.addEventListener('touchend', (e) => {
          const diff = touchStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 50) {
            const curIdx = state.quickViewImageIndex;
            const total = (state.quickViewProduct ? state.quickViewProduct.images || [] : []).length;
            if (diff > 0 && curIdx < total - 1) { state.quickViewImageIndex = curIdx + 1; renderQuickViewGallery(); }
            else if (diff < 0 && curIdx > 0) { state.quickViewImageIndex = curIdx - 1; renderQuickViewGallery(); }
          }
        }, { passive: true });
      }
    }

    const counter = document.getElementById('quickview-counter');
    if (counter) counter.textContent = `${idx + 1} / ${images.length}`;

    const thumbs = document.getElementById('quickview-thumbs');
    if (thumbs) {
      thumbs.innerHTML = images.map((img, i) => `
        <button type="button" data-index="${i}" style="flex-shrink:0; width:60px; height:60px; border:3px solid ${i === idx ? '#f97316' : '#e5e7eb'}; border-radius:8px; overflow:hidden; cursor:pointer; padding:3px; background:#f9fafb;">
          <img src="${img.thumb || img.src}" alt="" style="width:100%; height:100%; object-fit:contain;">
        </button>
      `).join('');
      
      thumbs.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
          state.quickViewImageIndex = parseInt(btn.dataset.index);
          renderQuickViewGallery();
        });
      });
      
      const activeThumb = thumbs.children[idx];
      if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    const prevBtn = document.getElementById('gallery-prev');
    const nextBtn = document.getElementById('gallery-next');
    if (prevBtn) prevBtn.style.display = images.length > 1 ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = images.length > 1 ? 'flex' : 'none';
  }

  function navigateGallery(dir) {
    const images = (state.quickViewProduct ? state.quickViewProduct.images : []);
    const newIdx = state.quickViewImageIndex + dir;
    if (newIdx >= 0 && newIdx < images.length) {
      state.quickViewImageIndex = newIdx;
      renderQuickViewGallery();
    }
  }

  function closeQuickView() {
    const modal = document.getElementById('quickview-modal');
    if (modal && modal.style.display !== 'none') {
      modal.style.display = 'none';
      unlockScroll();
    }
    state.quickViewProduct = null;
    state.quickViewSelectedSize = null;
    state.quickViewImageIndex = 0;
  }

  // ===========================================
  // ZOOM
  // ===========================================
  function openZoom(idx) {
    const p = state.quickViewProduct;
    if (!p) return;
    state.zoomImages = p.images || [];
    state.zoomIndex = idx;
    renderZoom();
    const modal = document.getElementById('zoom-modal');
    if (modal) { modal.style.display = 'flex'; lockScroll(); }
  }

  function renderZoom() {
    const images = state.zoomImages;
    const idx = state.zoomIndex;

    const counter = document.getElementById('zoom-counter');
    if (counter) counter.textContent = `${idx + 1} / ${images.length}`;

    const body = document.getElementById('zoom-body');
    if (body) body.innerHTML = `<img src="${((images[idx] && images[idx].src) || '')}" alt="" id="zoom-image">`;

    const prev = document.getElementById('zoom-prev');
    const next = document.getElementById('zoom-next');
    if (prev) prev.style.display = idx > 0 ? 'flex' : 'none';
    if (next) next.style.display = idx < images.length - 1 ? 'flex' : 'none';

    const thumbs = document.getElementById('zoom-thumbs');
    if (thumbs) {
      thumbs.innerHTML = images.map((img, i) => `
        <button class="bogo-zoom__thumb ${i === idx ? 'bogo-zoom__thumb--active' : ''}" data-index="${i}">
          <img src="${img.thumb || img.src}" alt="">
        </button>
      `).join('');
      thumbs.querySelectorAll('.bogo-zoom__thumb').forEach(t => {
        t.addEventListener('click', () => {
          state.zoomIndex = parseInt(t.dataset.index);
          renderZoom();
        });
      });
    }
  }

  function navigateZoom(dir) {
    const newIdx = state.zoomIndex + dir;
    if (newIdx >= 0 && newIdx < state.zoomImages.length) {
      state.zoomIndex = newIdx;
      renderZoom();
    }
  }

  function closeZoom() {
    const modal = document.getElementById('zoom-modal');
    if (modal && modal.style.display !== 'none') {
      modal.style.display = 'none';
      unlockScroll();
    }
    state.zoomImages = [];
    state.zoomIndex = 0;
  }

  // ===========================================
  // SIZE CHART — BRAND-AWARE (v4)
  // ===========================================
  const sizeChartData = {
    adults: [
      { men: 'M2', women: 'W4', uk: '1', eu: '33-34', cm: '21.0' },
      { men: 'M3', women: 'W5', uk: '2', eu: '34-35', cm: '22.0' },
      { men: 'M4', women: 'W6', uk: '3', eu: '36-37', cm: '22.9' },
      { men: 'M5', women: 'W7', uk: '4', eu: '37-38', cm: '23.8' },
      { men: 'M6', women: 'W8', uk: '5', eu: '38-39', cm: '24.6' },
      { men: 'M7', women: 'W9', uk: '6', eu: '39-40', cm: '25.4' },
      { men: 'M8', women: 'W10', uk: '7', eu: '41-42', cm: '26.2' },
      { men: 'M9', women: 'W11', uk: '8', eu: '42-43', cm: '27.1' },
      { men: 'M10', women: 'W12', uk: '9', eu: '43-44', cm: '27.9' },
      { men: 'M11', women: 'W13', uk: '10', eu: '44-45', cm: '28.8' },
      { men: 'M12', women: 'W14', uk: '11', eu: '46-47', cm: '29.6' },
      { men: 'M13', women: 'W15', uk: '12', eu: '48-49', cm: '30.5' },
    ],
    kids: [
      { size: 'C1', age: '<1 yr', eu: '16-17', uk: '0.5', cm: '8.2' },
      { size: 'C2', age: '<1 yr', eu: '17-18', uk: '1', cm: '9.0' },
      { size: 'C3', age: '<1 yr', eu: '18-19', uk: '2', cm: '9.8' },
      { size: 'C4', age: '1-2 yr', eu: '19-20', uk: '3', cm: '10.7' },
      { size: 'C5', age: '1-2 yr', eu: '20-21', uk: '4', cm: '11.5' },
      { size: 'C6', age: '2 yr', eu: '22-23', uk: '5', cm: '12.3' },
      { size: 'C7', age: '2-3 yr', eu: '23-24', uk: '6', cm: '13.2' },
      { size: 'C8', age: '3 yr', eu: '24-25', uk: '7', cm: '14.0' },
      { size: 'C9', age: '3-4 yr', eu: '25-26', uk: '8', cm: '14.8' },
      { size: 'C10', age: '4 yr', eu: '27', uk: '9', cm: '15.7' },
      { size: 'C11', age: '4-5 yr', eu: '28-29', uk: '10', cm: '16.5' },
      { size: 'C12', age: '5 yr', eu: '29-30', uk: '11', cm: '17.3' },
      { size: 'C13', age: '5-6 yr', eu: '30-31', uk: '12', cm: '18.2' },
      { size: 'J1', age: '6-7 yr', eu: '32-33', uk: '13', cm: '19.0' },
      { size: 'J2', age: '7-8 yr', eu: '33-34', uk: '1', cm: '19.8' },
      { size: 'J3', age: '8-9 yr', eu: '34-35', uk: '2', cm: '20.7' },
      { size: 'J4', age: '9-10 yr', eu: '36', uk: '3', cm: '21.5' },
      { size: 'J5', age: '10-11 yr', eu: '37', uk: '4', cm: '22.3' },
      { size: 'J6', age: '11-12 yr', eu: '38', uk: '5', cm: '23.2' },
    ]
  };

  // ===========================================
  // BRAND SIZE CHART DATA (inline for all brands)
  // UK is the primary key since that's what products use
  // ===========================================
  const brandSizeChartData = {
    nike: {
      label: 'Nike',
      tip: 'Nike tends to run slightly narrow. If you have wide feet, consider going half a size up.',
      men: [
        { uk: '5.5', us: '6.5', eu: '38.5', cm: '24' },
        { uk: '6',   us: '7',   eu: '40',   cm: '25' },
        { uk: '7',   us: '8',   eu: '41',   cm: '26' },
        { uk: '7.5', us: '8.5', eu: '42',   cm: '26.5' },
        { uk: '8',   us: '9',   eu: '42.5', cm: '27' },
        { uk: '8.5', us: '9.5', eu: '43',   cm: '27.5' },
        { uk: '9',   us: '10',  eu: '44',   cm: '28' },
        { uk: '9.5', us: '10.5',eu: '44.5', cm: '28.5' },
        { uk: '10',  us: '11',  eu: '45',   cm: '29' },
        { uk: '10.5',us: '11.5',eu: '45.5', cm: '29.5' },
        { uk: '11',  us: '12',  eu: '46',   cm: '30' },
        { uk: '12',  us: '13',  eu: '47.5', cm: '31' },
      ],
      women: [
        { uk: '2.5', us: '5',   eu: '35.5', cm: '22' },
        { uk: '3',   us: '5.5', eu: '36',   cm: '22.5' },
        { uk: '3.5', us: '6',   eu: '36.5', cm: '23' },
        { uk: '4',   us: '6.5', eu: '37.5', cm: '23.5' },
        { uk: '4.5', us: '7',   eu: '38',   cm: '24' },
        { uk: '5',   us: '7.5', eu: '38.5', cm: '24.5' },
        { uk: '5.5', us: '8',   eu: '39',   cm: '25' },
        { uk: '6',   us: '8.5', eu: '40',   cm: '25.5' },
        { uk: '6.5', us: '9',   eu: '40.5', cm: '26' },
        { uk: '7',   us: '9.5', eu: '41',   cm: '26.5' },
        { uk: '7.5', us: '10',  eu: '42',   cm: '27' },
        { uk: '8',   us: '10.5',eu: '42.5', cm: '27.5' },
      ]
    },
    adidas: {
      label: 'Adidas',
      tip: 'Adidas runs true to size for most styles. Ultraboost may run half size small.',
      men: [
        { uk: '5',   us: '5.5', eu: '38',   cm: '23.5' },
        { uk: '6',   us: '6.5', eu: '39.3', cm: '24.5' },
        { uk: '7',   us: '7.5', eu: '40.7', cm: '25.5' },
        { uk: '7.5', us: '8',   eu: '41.3', cm: '26' },
        { uk: '8',   us: '8.5', eu: '42',   cm: '26.5' },
        { uk: '8.5', us: '9',   eu: '42.7', cm: '27' },
        { uk: '9',   us: '9.5', eu: '43.3', cm: '27.5' },
        { uk: '9.5', us: '10',  eu: '44',   cm: '28' },
        { uk: '10',  us: '10.5',eu: '44.7', cm: '28.5' },
        { uk: '11',  us: '11.5',eu: '46',   cm: '29.5' },
        { uk: '12',  us: '12.5',eu: '47.3', cm: '30.5' },
      ],
      women: [
        { uk: '3',   us: '4.5', eu: '35.5', cm: '22' },
        { uk: '3.5', us: '5',   eu: '36',   cm: '22.5' },
        { uk: '4',   us: '5.5', eu: '36.7', cm: '23' },
        { uk: '4.5', us: '6',   eu: '37.3', cm: '23.5' },
        { uk: '5',   us: '6.5', eu: '38',   cm: '24' },
        { uk: '5.5', us: '7',   eu: '38.7', cm: '24.5' },
        { uk: '6',   us: '7.5', eu: '39.3', cm: '25' },
        { uk: '6.5', us: '8',   eu: '40',   cm: '25.5' },
        { uk: '7',   us: '8.5', eu: '40.7', cm: '26' },
        { uk: '8',   us: '9.5', eu: '42',   cm: '27' },
      ]
    },
    reebok: {
      label: 'Reebok',
      tip: 'Reebok Classic styles run true to size. Running shoes may run slightly narrow.',
      men: [
        { uk: '6',   us: '7',   eu: '39',   cm: '25' },
        { uk: '7',   us: '8',   eu: '40.5', cm: '26' },
        { uk: '7.5', us: '8.5', eu: '41',   cm: '26.5' },
        { uk: '8',   us: '9',   eu: '42',   cm: '27' },
        { uk: '8.5', us: '9.5', eu: '42.5', cm: '27.5' },
        { uk: '9',   us: '10',  eu: '43',   cm: '28' },
        { uk: '9.5', us: '10.5',eu: '43.5', cm: '28.5' },
        { uk: '10',  us: '11',  eu: '44.5', cm: '29' },
        { uk: '11',  us: '12',  eu: '45.5', cm: '30' },
        { uk: '12',  us: '13',  eu: '47',   cm: '31' },
      ],
      women: [
        { uk: '3.5', us: '6',   eu: '36',   cm: '23' },
        { uk: '4',   us: '6.5', eu: '37',   cm: '23.5' },
        { uk: '4.5', us: '7',   eu: '37.5', cm: '24' },
        { uk: '5',   us: '7.5', eu: '38',   cm: '24.5' },
        { uk: '5.5', us: '8',   eu: '38.5', cm: '25' },
        { uk: '6',   us: '8.5', eu: '39',   cm: '25.5' },
        { uk: '7',   us: '9.5', eu: '40.5', cm: '26.5' },
        { uk: '8',   us: '10.5',eu: '42',   cm: '27.5' },
      ]
    },
    asics: {
      label: 'Asics',
      tip: 'Asics generally run true to size. Gel-Kayano may run slightly narrow — consider half size up for wide feet.',
      men: [
        { uk: '5.5', us: '6.5', eu: '39.5', cm: '24.5' },
        { uk: '6',   us: '7',   eu: '40',   cm: '25' },
        { uk: '7',   us: '8',   eu: '41.5', cm: '26' },
        { uk: '7.5', us: '8.5', eu: '42',   cm: '26.5' },
        { uk: '8',   us: '9',   eu: '42.5', cm: '27' },
        { uk: '8.5', us: '9.5', eu: '43.5', cm: '27.5' },
        { uk: '9',   us: '10',  eu: '44',   cm: '28' },
        { uk: '9.5', us: '10.5',eu: '44.5', cm: '28.5' },
        { uk: '10',  us: '11',  eu: '45',   cm: '29' },
        { uk: '10.5',us: '11.5',eu: '46',   cm: '29.5' },
        { uk: '11',  us: '12',  eu: '46.5', cm: '30' },
        { uk: '12',  us: '13',  eu: '48',   cm: '31' },
      ],
      women: [
        { uk: '3',   us: '5',   eu: '35.5', cm: '22.5' },
        { uk: '3.5', us: '5.5', eu: '36',   cm: '23' },
        { uk: '4',   us: '6',   eu: '37',   cm: '23.5' },
        { uk: '4.5', us: '6.5', eu: '37.5', cm: '24' },
        { uk: '5',   us: '7',   eu: '38',   cm: '24.5' },
        { uk: '5.5', us: '7.5', eu: '39',   cm: '25' },
        { uk: '6',   us: '8',   eu: '39.5', cm: '25.5' },
        { uk: '6.5', us: '8.5', eu: '40',   cm: '26' },
        { uk: '7',   us: '9',   eu: '40.5', cm: '26.5' },
        { uk: '8',   us: '10',  eu: '42',   cm: '27.5' },
      ]
    },
    'new balance': {
      label: 'New Balance',
      tip: 'New Balance runs true to size. Their D-width is standard, 2E/4E are wide options.',
      men: [
        { uk: '6',   us: '6.5', eu: '39.5', cm: '24.5' },
        { uk: '6.5', us: '7',   eu: '40',   cm: '25' },
        { uk: '7',   us: '7.5', eu: '40.5', cm: '25.5' },
        { uk: '7.5', us: '8',   eu: '41.5', cm: '26' },
        { uk: '8',   us: '8.5', eu: '42',   cm: '26.5' },
        { uk: '8.5', us: '9',   eu: '42.5', cm: '27' },
        { uk: '9',   us: '9.5', eu: '43',   cm: '27.5' },
        { uk: '9.5', us: '10',  eu: '44',   cm: '28' },
        { uk: '10',  us: '10.5',eu: '44.5', cm: '28.5' },
        { uk: '10.5',us: '11',  eu: '45',   cm: '29' },
        { uk: '11',  us: '11.5',eu: '45.5', cm: '29.5' },
        { uk: '12',  us: '12.5',eu: '47',   cm: '30.5' },
      ],
      women: [
        { uk: '3',   us: '5',   eu: '35',   cm: '22' },
        { uk: '3.5', us: '5.5', eu: '36',   cm: '22.5' },
        { uk: '4',   us: '6',   eu: '36.5', cm: '23' },
        { uk: '4.5', us: '6.5', eu: '37',   cm: '23.5' },
        { uk: '5',   us: '7',   eu: '37.5', cm: '24' },
        { uk: '5.5', us: '7.5', eu: '38',   cm: '24.5' },
        { uk: '6',   us: '8',   eu: '39',   cm: '25' },
        { uk: '6.5', us: '8.5', eu: '40',   cm: '25.5' },
        { uk: '7',   us: '9',   eu: '40.5', cm: '26' },
        { uk: '8',   us: '10',  eu: '41.5', cm: '27' },
      ]
    },
    'under armour': {
      label: 'Under Armour',
      tip: 'Under Armour runs true to size. HOVR shoes may feel snug at first — they break in.',
      men: [
        { uk: '6',   us: '7',   eu: '40',   cm: '25' },
        { uk: '7',   us: '8',   eu: '41',   cm: '26' },
        { uk: '7.5', us: '8.5', eu: '42',   cm: '26.5' },
        { uk: '8',   us: '9',   eu: '42.5', cm: '27' },
        { uk: '8.5', us: '9.5', eu: '43',   cm: '27.5' },
        { uk: '9',   us: '10',  eu: '44',   cm: '28' },
        { uk: '9.5', us: '10.5',eu: '44.5', cm: '28.5' },
        { uk: '10',  us: '11',  eu: '45',   cm: '29' },
        { uk: '11',  us: '12',  eu: '46',   cm: '30' },
        { uk: '12',  us: '13',  eu: '47.5', cm: '31' },
      ],
      women: [
        { uk: '3',   us: '5.5', eu: '36',   cm: '22.5' },
        { uk: '3.5', us: '6',   eu: '36.5', cm: '23' },
        { uk: '4',   us: '6.5', eu: '37.5', cm: '23.5' },
        { uk: '4.5', us: '7',   eu: '38',   cm: '24' },
        { uk: '5',   us: '7.5', eu: '38.5', cm: '24.5' },
        { uk: '5.5', us: '8',   eu: '39',   cm: '25' },
        { uk: '6',   us: '8.5', eu: '40',   cm: '25.5' },
        { uk: '7',   us: '9.5', eu: '41',   cm: '26.5' },
      ]
    },
    skechers: {
      label: 'Skechers',
      tip: 'Skechers generally run true to size. Memory Foam styles may feel snugger initially.',
      men: [
        { uk: '6',   us: '7',   eu: '39.5', cm: '25' },
        { uk: '7',   us: '8',   eu: '41',   cm: '26' },
        { uk: '7.5', us: '8.5', eu: '41.5', cm: '26.5' },
        { uk: '8',   us: '9',   eu: '42',   cm: '27' },
        { uk: '8.5', us: '9.5', eu: '42.5', cm: '27.5' },
        { uk: '9',   us: '10',  eu: '43',   cm: '28' },
        { uk: '9.5', us: '10.5',eu: '44',   cm: '28.5' },
        { uk: '10',  us: '11',  eu: '44.5', cm: '29' },
        { uk: '11',  us: '12',  eu: '46',   cm: '30' },
        { uk: '12',  us: '13',  eu: '47.5', cm: '31' },
      ],
      women: [
        { uk: '3',   us: '6',   eu: '36',   cm: '23' },
        { uk: '4',   us: '7',   eu: '37',   cm: '24' },
        { uk: '5',   us: '8',   eu: '38',   cm: '25' },
        { uk: '5.5', us: '8.5', eu: '38.5', cm: '25.5' },
        { uk: '6',   us: '9',   eu: '39',   cm: '26' },
        { uk: '7',   us: '10',  eu: '40',   cm: '27' },
        { uk: '8',   us: '11',  eu: '41',   cm: '28' },
      ]
    },
    woodland: {
      label: 'Woodland',
      tip: 'Woodland shoes run true to UK size. Their leather shoes may feel tight initially — they stretch with wear.',
      men: [
        { uk: '5',   us: '6',   eu: '39',   cm: '24' },
        { uk: '6',   us: '7',   eu: '40',   cm: '25' },
        { uk: '7',   us: '8',   eu: '41',   cm: '26' },
        { uk: '8',   us: '9',   eu: '42',   cm: '27' },
        { uk: '9',   us: '10',  eu: '43',   cm: '28' },
        { uk: '10',  us: '11',  eu: '44',   cm: '29' },
        { uk: '11',  us: '12',  eu: '45',   cm: '30' },
        { uk: '12',  us: '13',  eu: '46',   cm: '31' },
      ],
      women: [
        { uk: '3',   us: '5',   eu: '36',   cm: '22.5' },
        { uk: '4',   us: '6',   eu: '37',   cm: '23.5' },
        { uk: '5',   us: '7',   eu: '38',   cm: '24.5' },
        { uk: '6',   us: '8',   eu: '39',   cm: '25.5' },
        { uk: '7',   us: '9',   eu: '40',   cm: '26.5' },
        { uk: '8',   us: '10',  eu: '41',   cm: '27.5' },
      ]
    }
  };

  function openSizeChart() {
    // v5: Brand-aware — all brands render inline (no more external pages)
    const qvVendor = (state.quickViewProduct && state.quickViewProduct.vendor);
    const brand = qvVendor || (state.selectedBrands.length === 1 ? state.selectedBrands[0] : null);
    
    if (brand && isCrocsBrand(brand)) {
      openCrocsSizeChart();
      return;
    }
    
    if (brand) {
      const brandKey = brand.toLowerCase().trim();
      // Check if we have inline data for this brand
      const chartData = brandSizeChartData[brandKey] || findBrandChartData(brandKey);
      if (chartData) {
        openBrandInlineSizeChart(brandKey, chartData);
        return;
      }
    }
    
    // No brand selected or unknown: show brand picker
    openBrandPicker();
  }

  // Fuzzy match brand key (e.g. "Under Armour Shoes" → "under armour")
  function findBrandChartData(vendorKey) {
    for (const [brand, data] of Object.entries(brandSizeChartData)) {
      if (vendorKey.includes(brand) || brand.includes(vendorKey)) return data;
    }
    return null;
  }

  // v5: Generic inline size chart for any brand (UK-primary)
  function openBrandInlineSizeChart(brandKey, chartData) {
    log('Opening inline size chart for:', chartData.label);
    const modal = document.getElementById('sizechart-modal');
    const title = document.getElementById('sizechart-title');
    const body = document.getElementById('sizechart-body');
    if (!modal || !body) return;

    const cat = state.activeCategory;
    const selectedSizes = state.selectedSizes[cat] || [];
    const cellStyle = 'padding:10px 6px; text-align:center; border-bottom:1px solid #e5e7eb; font-size:13px;';
    const headStyle = 'padding:12px 6px; text-align:center; border-bottom:2px solid #1e1b4b; font-size:12px; font-weight:700; color:#1e1b4b; text-transform:uppercase; letter-spacing:0.5px;';

    const backLink = state.availableBrands.length > 1 
      ? `<div style="text-align:center; margin-bottom:12px;"><button type="button" id="sizechart-back-brands" style="background:none; border:none; color:#f97316; font-size:13px; font-weight:600; cursor:pointer;">← All Brands Size Charts</button></div>` 
      : '';

    const catLabel = cat === 'men' ? "Men's" : "Women's";
    const genderIcon = cat === 'men' ? '👨' : '👩';
    if (title) title.textContent = `${genderIcon} ${chartData.label} ${catLabel} Size Chart`;

    // Pick the right gender data (fallback to men if women not available for this brand)
    const sizeRows = (cat === 'women' && chartData.women) ? chartData.women : chartData.men;

    if (!sizeRows || sizeRows.length === 0) {
      body.innerHTML = `${backLink}<div style="text-align:center; padding:32px 16px; color:#6b7280;">No size data available for ${chartData.label} ${catLabel}.</div>`;
      if (modal.style.display !== 'flex') lockScroll();
      modal.style.display = 'flex';
      return;
    }

    // Normalize selected sizes for highlight matching
    const selNorms = selectedSizes.map(s => s.replace(/\s+/g, '').toUpperCase().replace(/^UK/,'').replace(/UK$/,''));

    const rows = sizeRows.map(r => {
      const isActive = selNorms.includes(r.uk);
      const rowBg = isActive ? 'background:rgba(249,115,22,0.1);' : '';
      const sizeWeight = isActive ? 'font-weight:800; color:#f97316;' : 'font-weight:600;';
      return `<tr style="${rowBg}">
        <td style="${cellStyle} ${sizeWeight}">UK ${r.uk}</td>
        <td style="${cellStyle}">US ${r.us}</td>
        <td style="${cellStyle}">EU ${r.eu}</td>
        <td style="${cellStyle}">${r.cm} cm</td>
      </tr>`;
    }).join('');

    body.innerHTML = `${backLink}
      <table style="width:100%; border-collapse:collapse;">
        <thead><tr style="background:#f9fafb;">
          <th style="${headStyle}">UK</th>
          <th style="${headStyle}">US</th>
          <th style="${headStyle}">EU</th>
          <th style="${headStyle}">Foot (CM)</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>
      <div style="margin-top:16px; padding:14px; background:#ede9f5; border-radius:10px; font-size:13px; color:#312e81;">
        💡 <strong>Tip:</strong> ${chartData.tip}
      </div>
      <div style="margin-top:10px; padding:12px; background:#f9fafb; border-radius:10px; font-size:12px; color:#6b7280; text-align:center;">
        📐 <strong>How to measure:</strong> Stand on paper → Trace foot → Measure heel to longest toe in CM
      </div>
    `;

    safeOn('sizechart-back-brands', 'click', () => { openBrandPicker(); });
    if (modal.style.display !== 'flex') lockScroll();
    modal.style.display = 'flex';
  }

  function openCrocsSizeChart() {
    log('Opening Crocs size chart');
    const modal = document.getElementById('sizechart-modal');
    const title = document.getElementById('sizechart-title');
    const body = document.getElementById('sizechart-body');
    if (!modal || !body) return;

    const cat = state.activeCategory;
    const selectedSizes = state.selectedSizes[cat] || [];
    const cellStyle = 'padding:10px 6px; text-align:center; border-bottom:1px solid #e5e7eb; font-size:13px;';
    const headStyle = 'padding:12px 6px; text-align:center; border-bottom:2px solid #1e1b4b; font-size:12px; font-weight:700; color:#1e1b4b; text-transform:uppercase; letter-spacing:0.5px;';

    // Show "All Brands" back link if multiple brands exist
    const backLink = state.availableBrands.length > 1 
      ? `<div style="text-align:center; margin-bottom:12px;"><button type="button" id="sizechart-back-brands" style="background:none; border:none; color:#f97316; font-size:13px; font-weight:600; cursor:pointer;">← All Brands Size Charts</button></div>` 
      : '';

    if (cat === 'kids') {
      if (title) title.textContent = '👶 Crocs Kids Size Chart';
      
      const rows = sizeChartData.kids.map(r => {
        const isActive = selectedSizes.some(s => r.size.toUpperCase() === s.toUpperCase());
        const rowBg = isActive ? 'background:rgba(249,115,22,0.1);' : '';
        const sizeWeight = isActive ? 'font-weight:800; color:#f97316;' : 'font-weight:600;';
        return `<tr style="${rowBg}">
          <td style="${cellStyle} ${sizeWeight}">${r.size}</td>
          <td style="${cellStyle} color:#f97316; font-weight:600;">${r.age}</td>
          <td style="${cellStyle}">${r.cm}</td>
          <td style="${cellStyle}">${r.eu}</td>
          <td style="${cellStyle}">${r.uk}</td>
        </tr>`;
      }).join('');

      body.innerHTML = `${backLink}
        <table style="width:100%; border-collapse:collapse;">
          <thead><tr style="background:#f9fafb;">
            <th style="${headStyle}">US</th>
            <th style="${headStyle}">Age</th>
            <th style="${headStyle}">CM</th>
            <th style="${headStyle}">EU</th>
            <th style="${headStyle}">UK</th>
          </tr></thead>
          <tbody>${rows}</tbody>
        </table>
        <div style="margin-top:16px; padding:14px; background:#fff7ed; border-radius:10px; font-size:13px; color:#9a3412; border:1px solid #fed7aa;">
          💡 <strong>Tip:</strong> If between sizes, round up. Junior 3+ can also shop adult sizes.
        </div>
      `;
    } else {
      if (title) title.textContent = cat === 'men' ? '👨 Crocs Men\'s Size Chart' : '👩 Crocs Women\'s Size Chart';
      
      const rows = sizeChartData.adults.map(r => {
        const checkSize = cat === 'men' ? r.men : r.women;
        const isActive = selectedSizes.some(s => checkSize.toUpperCase() === s.toUpperCase());
        const rowBg = isActive ? 'background:rgba(249,115,22,0.1);' : '';
        const sizeWeight = isActive ? 'font-weight:800; color:#f97316;' : 'font-weight:600;';
        return `<tr style="${rowBg}">
          <td style="${cellStyle} ${sizeWeight}">${r.men}</td>
          <td style="${cellStyle} ${sizeWeight}">${r.women}</td>
          <td style="${cellStyle}">${r.cm}</td>
          <td style="${cellStyle}">${r.eu}</td>
          <td style="${cellStyle}">${r.uk}</td>
        </tr>`;
      }).join('');

      body.innerHTML = `${backLink}
        <table style="width:100%; border-collapse:collapse;">
          <thead><tr style="background:#f9fafb;">
            <th style="${headStyle}">US Men</th>
            <th style="${headStyle}">US Women</th>
            <th style="${headStyle}">CM</th>
            <th style="${headStyle}">EU</th>
            <th style="${headStyle}">UK</th>
          </tr></thead>
          <tbody>${rows}</tbody>
        </table>
        <div style="margin-top:16px; padding:14px; background:#ede9f5; border-radius:10px; font-size:13px; color:#312e81;">
          💡 <strong>Tip:</strong> Crocs run true to size. Measure heel to toe in CM for best fit.
        </div>
      `;
    }

    // Bind back button
    safeOn('sizechart-back-brands', 'click', () => {
      openBrandPicker();
    });

    if (modal.style.display !== 'flex') lockScroll();
    modal.style.display = 'flex';
  }

  function openBrandPicker() {
    const modal = document.getElementById('sizechart-modal');
    const title = document.getElementById('sizechart-title');
    const body = document.getElementById('sizechart-body');
    if (!modal || !body) return;

    if (title) title.textContent = '📏 Size Charts by Brand';

    // Build brand list from available brands that have chart data
    const brands = state.availableBrands
      .filter(b => b !== 'All')
      .map(b => {
        const key = b.toLowerCase().trim();
        const isCrocs = isCrocsBrand(b);
        const hasInlineData = isCrocs || !!brandSizeChartData[key] || !!findBrandChartData(key);
        return { brand: b, key, isCrocs, hasInlineData };
      });

    body.innerHTML = `
      <div class="bogo-brand-grid">
        ${brands.map(({ brand, key, isCrocs, hasInlineData }) => {
          const hint = isCrocs ? 'US · UK · EU · CM' : 'UK · US · EU · CM';
          return `<button type="button" class="bogo-brand-card" data-brand-key="${key}" data-is-crocs="${isCrocs}">
            <span class="bogo-brand-card__name">${brand}</span>
            <span class="bogo-brand-card__hint">${hint}</span>
          </button>`;
        }).join('')}
      </div>
    `;

    body.querySelectorAll('.bogo-brand-card').forEach(card => {
      card.addEventListener('click', () => {
        const brandKey = card.dataset.brandKey;
        const isCrocs = card.dataset.isCrocs === 'true';
        if (isCrocs) {
          openCrocsSizeChart();
        } else {
          const chartData = brandSizeChartData[brandKey] || findBrandChartData(brandKey);
          if (chartData) {
            openBrandInlineSizeChart(brandKey, chartData);
          } else {
            // Fallback: open external page if no inline data
            const url = getBrandChartUrl(brandKey);
            if (url) window.open(url, '_blank');
          }
        }
      });
    });

    if (modal.style.display !== 'flex') lockScroll();
    modal.style.display = 'flex';
  }
  
  function closeSizeChart() {
    const modal = document.getElementById('sizechart-modal');
    if (modal && modal.style.display !== 'none') {
      modal.style.display = 'none';
      unlockScroll();
    }
  }

  // ===========================================
  // BOGO LOGIC
  // ===========================================
  function addToBogoFromQuickView() {
    const p = state.quickViewProduct;
    const size = state.quickViewSelectedSize;
    if (!p || !size) return;

    const variant = p.variants.find(v => v.size === size);
    if (!variant) return;

    const item = {
      ...p,
      selectedSize: size,
      selectedVariantId: variant.id,
      price: variant.price,
      uniqueId: `${p.id}-${size}-${Date.now()}`
    };

    if (!state.bogoSelection.first) {
      state.bogoSelection.first = item;
      showToast(`✓ ${cleanTitle(p.title)} selected! Now pick your FREE item 🎁`, 'success');
      startNudgeTimer();
    } else if (!state.bogoSelection.second) {
      state.bogoSelection.second = item;
      clearNudgeTimer();
      showToast("🎉 Both items selected! Review & add to cart", 'success');
    } else {
      // v5: Both slots filled — ask which to replace instead of silent reset
      state._pendingReplaceItem = item;
      showReplaceModal();
    }

    closeQuickView();
    updateUI();
  }

  function clearBogoSelection() {
    state.bogoSelection = { first: null, second: null };
    updateUI();
    showToast("Selections cleared · Pick your first item again", 'info');
  }

  // ===========================================
  // REPLACE MODAL — v5: Ask which slot to swap
  // ===========================================
  function showReplaceModal() {
    const modal = document.getElementById('bogo-replace-modal');
    if (!modal) return;
    
    const first = state.bogoSelection.first;
    const second = state.bogoSelection.second;
    const pending = state._pendingReplaceItem;
    if (!first || !second || !pending) return;

    // Populate "new item" preview
    var newThumb = document.getElementById('replace-new-thumb');
    var newName = document.getElementById('replace-new-name');
    var newSize = document.getElementById('replace-new-size');
    if (newThumb) newThumb.src = getImgUrl(pending);
    if (newName) newName.textContent = cleanTitle(pending.title);
    if (newSize) newSize.textContent = formatSize(pending.selectedSize);

    // Populate slot 1 (Item 1) card
    var thumb1 = document.getElementById('replace-slot1-thumb');
    var name1 = document.getElementById('replace-slot1-name');
    var size1 = document.getElementById('replace-slot1-size');
    if (thumb1) thumb1.src = getImgUrl(first);
    if (name1) name1.textContent = cleanTitle(first.title);
    if (size1) size1.textContent = formatSize(first.selectedSize);

    // Populate slot 2 (Item 2) card
    var thumb2 = document.getElementById('replace-slot2-thumb');
    var name2 = document.getElementById('replace-slot2-name');
    var size2 = document.getElementById('replace-slot2-size');
    if (thumb2) thumb2.src = getImgUrl(second);
    if (name2) name2.textContent = cleanTitle(second.title);
    if (size2) size2.textContent = formatSize(second.selectedSize);

    modal.style.display = 'flex';
    lockScroll();
  }

  function replaceSlot(slot) {
    var pending = state._pendingReplaceItem;
    if (!pending) return;

    if (slot === 'first') {
      var oldName = cleanTitle(state.bogoSelection.first.title);
      state.bogoSelection.first = pending;
      showToast('✓ Replaced Item 1 · ' + cleanTitle(pending.title) + ' is now your paid item', 'success');
    } else {
      var oldName = cleanTitle(state.bogoSelection.second.title);
      state.bogoSelection.second = pending;
      showToast('🎁 Replaced FREE Item · ' + cleanTitle(pending.title) + ' is now your free item', 'success');
    }

    state._pendingReplaceItem = null;
    var modal = document.getElementById('bogo-replace-modal');
    if (modal) modal.style.display = 'none';
    unlockScroll();
    updateUI();
  }

  function cancelReplace() {
    var modal = document.getElementById('bogo-replace-modal');
    if (!modal || modal.style.display === 'none' || modal.style.display === '') return;
    state._pendingReplaceItem = null;
    modal.style.display = 'none';
    unlockScroll();
    showToast('Selection kept as is 👍', 'info');
  }

  function calculateBogo() {
    const { first, second } = state.bogoSelection;
    if (!first || !second) return null;

    const [paidItem, freeItem] = first.price >= second.price 
      ? [first, second] 
      : [second, first];

    return {
      paidItem,
      freeItem,
      total: paidItem.price,
      savings: freeItem.price
    };
  }

  // ===========================================
  // CART
  // ===========================================
  function addToCart() {
    const { first, second } = state.bogoSelection;
    if (!first || !second) return;

    const calc = calculateBogo();
    
    const overlay = document.getElementById('bogo-confirm-overlay');
    if (!overlay) { proceedToCart(); return; }
    
    const itemsEl = document.getElementById('confirm-items');
    const totalEl = document.getElementById('confirm-total');
    
    if (itemsEl) {
      const paidImg = getImgUrl(calc.paidItem);
      const freeImg = getImgUrl(calc.freeItem);
      itemsEl.innerHTML = `
        <div class="bogo-confirm-row bogo-confirm-row--paid">
          <img src="${paidImg}" alt="" class="bogo-confirm-row__img">
          <div class="bogo-confirm-row__info">
            <div class="bogo-confirm-row__name">${cleanTitle(calc.paidItem.title)}</div>
            <div class="bogo-confirm-row__detail">Size: ${formatSize(calc.paidItem.selectedSize)} · ${calc.paidItem.vendor || 'MassDeals'}</div>
          </div>
          <div class="bogo-confirm-row__price">${formatPrice(calc.paidItem.price)}</div>
        </div>
        <div class="bogo-confirm-row bogo-confirm-row--free">
          <img src="${freeImg}" alt="" class="bogo-confirm-row__img">
          <div class="bogo-confirm-row__info">
            <div class="bogo-confirm-row__name">${cleanTitle(calc.freeItem.title)}</div>
            <div class="bogo-confirm-row__detail bogo-confirm-row__detail--free">Size: ${formatSize(calc.freeItem.selectedSize)} · ${calc.freeItem.vendor || 'MassDeals'}</div>
          </div>
          <div class="bogo-confirm-row__price bogo-confirm-row__price--free">FREE</div>
        </div>
      `;
    }
    
    if (totalEl) {
      totalEl.innerHTML = `You pay <strong>${formatPrice(calc.total)}</strong> for 2 items · Save <strong style="color:#22c55e">${formatPrice(calc.savings)}</strong>`;
    }
    
    overlay.style.display = 'flex';
    lockScroll();
  }
  
  function proceedToCart() {
    const { first, second } = state.bogoSelection;
    if (!first || !second) return;

    // Guard against double-clicks
    if (state._addingToCart) return;
    state._addingToCart = true;

    const calc = calculateBogo();

    // Show loading state on the confirm button
    const confirmBtn = document.getElementById('confirm-checkout-btn');
    var confirmBtnOrigText = '';
    if (confirmBtn) {
      confirmBtnOrigText = confirmBtn.innerHTML;
      confirmBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;justify-content:center;"><svg width="18" height="18" viewBox="0 0 24 24" style="animation:bogo-spin 0.8s linear infinite;"><circle cx="12" cy="12" r="10" stroke="#fff" stroke-width="3" fill="none" stroke-dasharray="31 31" stroke-linecap="round"/></svg> Adding to Cart...</span>';
      confirmBtn.disabled = true;
      confirmBtn.style.opacity = '0.7';
      confirmBtn.style.pointerEvents = 'none';
    }
    // Also disable cancel button during add
    const cancelBtn = document.getElementById('confirm-cancel-btn');
    if (cancelBtn) { cancelBtn.disabled = true; cancelBtn.style.opacity = '0.5'; cancelBtn.style.pointerEvents = 'none'; }

    showToast("Adding to cart...", 'info');

    const items = [
      { id: calc.paidItem.selectedVariantId, quantity: 1 },
      { 
        id: calc.freeItem.selectedVariantId, 
        quantity: 1,
        properties: {
          '_bogo': 'free',
          '_bogo_pair': calc.paidItem.selectedVariantId.toString()
        }
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(r => {
      if (!r.ok) throw new Error('Failed to add to cart');
      return r.json();
    })
    .then(() => {
      state.cartPairs.push({
        paid: calc.paidItem,
        free: calc.freeItem,
        total: calc.total,
        savings: calc.savings
      });
      
      const overlay = document.getElementById('bogo-confirm-overlay');
      if (overlay) overlay.style.display = 'none';
      
      showAddMoreOverlay();
    })
    .catch(e => {
      console.error('Cart error:', e);
      showToast("Failed to add to cart. Please try again.", 'error');
    })
    .finally(() => {
      state._addingToCart = false;
      if (confirmBtn) {
        confirmBtn.innerHTML = confirmBtnOrigText;
        confirmBtn.disabled = false;
        confirmBtn.style.opacity = '';
        confirmBtn.style.pointerEvents = '';
      }
      if (cancelBtn) { cancelBtn.disabled = false; cancelBtn.style.opacity = ''; cancelBtn.style.pointerEvents = ''; }
    });
  }

  // ===========================================
  // "ADD MORE?" OVERLAY
  // ===========================================
  function showAddMoreOverlay() {
    const totalItems = state.cartPairs.length * 2;
    const totalFree = state.cartPairs.length;
    const totalPaid = state.cartPairs.reduce((s, p) => s + p.total, 0);
    const totalSavings = state.cartPairs.reduce((s, p) => s + p.savings, 0);
    
    let overlay = document.getElementById('bogo-addmore-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'bogo-addmore-overlay';
      overlay.className = 'bogo-overlay';
      document.body.appendChild(overlay);
    }
    
    overlay.innerHTML = `
      <div class="bogo-overlay__card">
        <div class="bogo-overlay__emoji">🎉</div>
        <h3 class="bogo-overlay__title">Added to Cart!</h3>
        <p class="bogo-overlay__subtitle">
          ${totalItems} items · ${totalFree} FREE · You pay ${formatPrice(totalPaid)} · Save ${formatPrice(totalSavings)}
        </p>
        
        <div class="bogo-overlay__promo">
          <div class="bogo-overlay__promo-title">🔥 Want another FREE pair?</div>
          <div class="bogo-overlay__promo-text">Pick 2 more → cheapest is FREE again!</div>
        </div>
        
        <button type="button" id="addmore-yes-btn" class="bogo-overlay__btn-primary">
          + Add Another Pair
        </button>
        <button type="button" id="addmore-cart-btn" class="bogo-overlay__btn-secondary">
          Go to Cart (${totalItems} items) →
        </button>
        <button type="button" id="addmore-edit-btn" class="bogo-overlay__btn-ghost">
          ← Edit Last Selection
        </button>
        <div class="bogo-overlay__footer-note">🔒 COD · UPI · Cards · GST Bill · Easy Returns</div>
      </div>
    `;
    
    overlay.style.display = 'flex';
    
    document.getElementById('addmore-yes-btn').addEventListener('click', () => {
      overlay.style.display = 'none';
      unlockScroll();
      state.bogoSelection = { first: null, second: null };
      state.currentPairNum = state.cartPairs.length + 1;
      updateUI();
      showToast(`Pick pair #${state.currentPairNum} — select your first item!`, 'info');
    });
    
    document.getElementById('addmore-cart-btn').addEventListener('click', () => {
      overlay.style.display = 'none';
      unlockScroll();
      openCartDrawer();
    });

    document.getElementById('addmore-edit-btn').addEventListener('click', () => {
      // Remove last pair from Shopify cart, then let user re-pick
      const lastPair = state.cartPairs.pop();
      if (!lastPair) return;

      // Show loading state on all buttons
      const editBtn = document.getElementById('addmore-edit-btn');
      const yesBtn = document.getElementById('addmore-yes-btn');
      const cartBtn = document.getElementById('addmore-cart-btn');
      if (editBtn) {
        editBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:6px;justify-content:center;"><svg width="16" height="16" viewBox="0 0 24 24" style="animation:bogo-spin 0.8s linear infinite;"><circle cx="12" cy="12" r="10" stroke="#6b7280" stroke-width="3" fill="none" stroke-dasharray="31 31" stroke-linecap="round"/></svg> Removing from cart...</span>';
        editBtn.disabled = true; editBtn.style.opacity = '0.6'; editBtn.style.pointerEvents = 'none';
      }
      if (yesBtn) { yesBtn.disabled = true; yesBtn.style.opacity = '0.5'; yesBtn.style.pointerEvents = 'none'; }
      if (cartBtn) { cartBtn.disabled = true; cartBtn.style.opacity = '0.5'; cartBtn.style.pointerEvents = 'none'; }

      // Atomic removal: fetch cart once, find both keys, remove in single call
      removeBogoCartPair(lastPair.paid.selectedVariantId, lastPair.free.selectedVariantId)
        .then(() => {
          // Dispatch cart update event for theme after removal
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          overlay.style.display = 'none';
          unlockScroll();
          state.bogoSelection = { first: null, second: null };
          updateUI();
          showToast('Removed from cart — pick your items again!', 'info');
        })
        .catch(() => {
          overlay.style.display = 'none';
          unlockScroll();
          state.bogoSelection = { first: null, second: null };
          updateUI();
          showToast('Error removing from cart. Please check your cart.', 'error');
        });
    });
  }

  // Remove a BOGO pair from cart atomically (single /cart/update.js call)
  // Prevents "broken pair" state where one item is removed but the other isn't
  function removeBogoCartPair(paidVariantId, freeVariantId) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var updates = {};
        var found = 0;
        cart.items.forEach(function(item) {
          var vid = String(item.variant_id);
          if (vid === String(paidVariantId) || vid === String(freeVariantId)) {
            updates[item.key] = 0;
            found++;
          }
        });
        if (found === 0) {
          log('No matching items found in cart for removal');
          return Promise.resolve();
        }
        // Single atomic call — either both are removed or neither
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart update failed: ' + r.status);
          return r.json();
        })
        .then(function() {
          log('Removed BOGO pair from cart:', paidVariantId, freeVariantId);
        });
      });
  }

  // Remove a single variant from Shopify cart (returns Promise)
  // Uses cart item `key` for reliable removal (variant ID alone fails with line item properties)
  function removeFromShopifyCart(variantId) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Find the line item matching this variant ID
        var item = cart.items.find(function(i) { return i.variant_id === variantId || String(i.variant_id) === String(variantId); });
        if (!item) {
          log('Variant not found in cart for removal:', variantId);
          return Promise.resolve();
        }
        // Use the unique `key` for reliable removal
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          log('Removed variant from cart via key:', variantId, item.key);
        });
      })
      .catch(function(e) { log('Remove from cart error:', e); });
  }

  // Sync BOGO state with actual Shopify cart (e.g. user removed items from cart drawer)
  function syncCartState() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        const cartVariantIds = new Set(cart.items.map(i => i.variant_id));
        
        // ONLY clean up committed cartPairs (items that were actually added to cart).
        // Do NOT touch state.bogoSelection — that's the user's in-progress pick
        // and those items haven't been added to cart yet, so checking the cart
        // for them would incorrectly clear the user's selection.
        var beforeCount = state.cartPairs.length;
        state.cartPairs = state.cartPairs.filter(pair => {
          return cartVariantIds.has(pair.paid.selectedVariantId) && cartVariantIds.has(pair.free.selectedVariantId);
        });
        
        if (state.cartPairs.length !== beforeCount) {
          state.currentPairNum = state.cartPairs.length + 1;
          updateUI();
        }
        
        log('Cart sync complete. Cart items:', cart.item_count, 'BOGO pairs:', state.cartPairs.length);
      })
      .catch(e => log('Cart sync error:', e));
  }

  // ===========================================
  // CART DRAWER
  // ===========================================
  function openCartDrawer() {
    log('Opening cart drawer...');
    
    const srTriggers = ['[data-sr-cart-toggle]', '.sr-cart-trigger', '#sr-cart-trigger', '.sr-smart-cart-trigger', '[data-sr-cart]', '.sr-cart-icon'];
    for (const sel of srTriggers) {
      const el = document.querySelector(sel);
      if (el) { el.click(); return; }
    }
    
    const headerArea = document.querySelector('[data-section-type="header"]') || document.querySelector('.site-header') || document.querySelector('header');
    if (headerArea) {
      const cartEl = headerArea.querySelector('[data-cart-toggle]') || headerArea.querySelector('.cart-link') || headerArea.querySelector('a[href="/cart"]');
      if (cartEl) { cartEl.click(); return; }
    }
    
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }, bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
    
    setTimeout(() => {
      const srDrawer = document.querySelector('[class*="sr-cart"], [class*="sr-drawer"], [class*="smart-cart"]');
      if (srDrawer && getComputedStyle(srDrawer).display !== 'none') return;
      
      const atcBtn = document.querySelector('[data-atc-banner-cart-button]');
      if (atcBtn) { atcBtn.click(); return; }
      
      const anyCart = document.querySelector('a[href="/cart"]');
      if (anyCart) { anyCart.click(); return; }
      
      window.location.href = '/cart';
    }, 800);
  }

  // ===========================================
  // EVENT BINDINGS
  // ===========================================
  function bindEvents() {
    const qvModal = document.getElementById('quickview-modal');
    if (qvModal) {
      let qvStartX = 0, qvStartY = 0;
      qvModal.addEventListener('touchstart', (e) => {
        qvStartX = e.touches[0].clientX;
        qvStartY = e.touches[0].clientY;
      }, { passive: true });
      qvModal.addEventListener('touchmove', (e) => {
        const dx = Math.abs(e.touches[0].clientX - qvStartX);
        const dy = Math.abs(e.touches[0].clientY - qvStartY);
        if (dx > dy && dx > 10 && qvStartX < 40) {
          e.preventDefault();
        }
      }, { passive: false });
    }

    // Category tabs
    document.querySelectorAll('.bogo-tab').forEach(tab => {
      tab.addEventListener('click', function() { switchCategory(tab.dataset.category); });
    });

    // v4.3: Make BOGO slots clickable
    // "Tap to Start ↓" → scroll down to size bar area (don't open modal — user picks gender first)
    var slotFirst = document.getElementById('bogo-slot-first');
    var slotSecond = document.getElementById('bogo-slot-second');
    
    function handleEmptySlotTap(slot) {
      if (!slot) return;
      slot.addEventListener('click', function() {
        var card = slot.querySelector('.bogo-slot__card');
        if (card && card.classList.contains('bogo-slot__card--empty')) {
          // Scroll to size bar / tabs area so user sees the gender tabs + size button
          var sizeBar = document.getElementById('bogo-filter-bar') || document.querySelector('.bogo-tabs');
          if (sizeBar) {
            sizeBar.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    }
    handleEmptySlotTap(slotFirst);
    handleEmptySlotTap(slotSecond);

    // v4.3: Hero banner tap → scroll down to tabs/size area
    var heroSection = document.querySelector('.bogo-hero');
    if (heroSection) {
      heroSection.addEventListener('click', function(e) {
        // Don't intercept if they tapped a filled slot (has product image)
        if (e.target.closest('.bogo-slot__card--filled')) return;
        // Don't intercept if they tapped a link or button
        if (e.target.closest('a') || e.target.closest('button')) return;
        var tabsEl = document.getElementById('bogo-tabs') || document.querySelector('.bogo-tabs');
        if (tabsEl) {
          tabsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // v4.3: "Pick FREE" bottom bar tap → scroll to products grid + show clear toast
    var partialBar = document.getElementById('bottom-bar-partial');
    if (partialBar) {
      partialBar.addEventListener('click', function(e) {
        // Don't intercept the clear (✕) button
        if (e.target.closest('.bogo-bottom-bar__clear')) return;
        scrollToProducts();
        // Pulse the grid briefly to draw attention
        var gridEl = document.getElementById('bogo-grid');
        if (gridEl) {
          gridEl.style.outline = '3px solid #22c55e';
          gridEl.style.outlineOffset = '4px';
          gridEl.style.borderRadius = '12px';
          setTimeout(function() {
            gridEl.style.outline = 'none';
            gridEl.style.outlineOffset = '0';
          }, 1500);
        }
        showToast('👇 Tap any product below to get it FREE!', 'success');
      });
    }

    // v4.3: Bar pair remove buttons
    safeOn('bar-remove-first', 'click', function(e) {
      e.stopPropagation();
      if (state.bogoSelection.first && state.bogoSelection.second) {
        state.bogoSelection.first = state.bogoSelection.second;
        state.bogoSelection.second = null;
        showToast('Removed! ' + cleanTitle(state.bogoSelection.first.title) + ' is now your pick. Choose your FREE item 🎁', 'info');
      } else if (state.bogoSelection.first) {
        state.bogoSelection.first = null;
        showToast('Selection removed · Tap any product to start', 'info');
      }
      updateUI();
    });
    safeOn('bar-remove-second', 'click', function(e) {
      e.stopPropagation();
      if (state.bogoSelection.second) {
        state.bogoSelection.second = null;
        showToast('Removed! Now pick your FREE item 🎁', 'info');
      }
      updateUI();
    });

    // Product card clicks (delegation)
    const grid = document.getElementById('bogo-grid');
    if (grid) {
      grid.addEventListener('click', (e) => {
        // Handle deselect button
        const deselectBtn = e.target.closest('.bogo-card__deselect');
        if (deselectBtn) {
          e.stopPropagation();
          const which = deselectBtn.dataset.deselect;
          if (which === 'first' && state.bogoSelection.second) {
            state.bogoSelection.first = state.bogoSelection.second;
            state.bogoSelection.second = null;
            showToast(`Removed! ${cleanTitle(state.bogoSelection.first.title)} is now your pick. Choose your FREE item 🎁`, 'info');
          } else if (which === 'first') {
            state.bogoSelection.first = null;
            showToast('Selection removed · Tap any product to start', 'info');
          } else if (which === 'second') {
            state.bogoSelection.second = null;
            showToast('Removed! Now pick your FREE item 🎁', 'info');
          }
          updateUI();
          return;
        }

        const card = e.target.closest('.bogo-card');
        if (card) {
          const productId = parseInt(card.dataset.productId);
          const product = state.allProducts.find(p => p.id === productId);
          if (!product) return;
          
          const isFirst = (state.bogoSelection.first && state.bogoSelection.first.id) === productId;
          const isSecond = (state.bogoSelection.second && state.bogoSelection.second.id) === productId;
          
          if (isFirst || isSecond) {
            // If both products are selected, scroll to bottom bar
            if (state.bogoSelection.first && state.bogoSelection.second) {
              var bottomBar = document.getElementById('bogo-bottom-bar');
              if (bottomBar) {
                bottomBar.scrollIntoView({ behavior: 'smooth', block: 'end' });
              }
              return;
            }
            // Only one selected — allow deselection
            if (isFirst && state.bogoSelection.second) {
              state.bogoSelection.first = state.bogoSelection.second;
              state.bogoSelection.second = null;
              showToast(`Removed! ${cleanTitle(state.bogoSelection.first.title)} is now your pick. Choose your FREE item 🎁`, 'info');
            } else if (isFirst) {
              state.bogoSelection.first = null;
              showToast('Selection removed · Tap any product to start', 'info');
            } else if (isSecond) {
              state.bogoSelection.second = null;
              showToast(`Removed! Now pick your FREE item 🎁`, 'info');
            }
            updateUI();
          } else {
            openQuickView(product);
          }
        }
      });
    }

    // === DELEGATED FILTER CHIP LISTENERS (single listener per container) ===
    
    // Brand chips delegation
    const brandContainer = document.getElementById('filter-brand-chips');
    if (brandContainer) {
      brandContainer.addEventListener('click', (e) => {
        const chip = e.target.closest('.bogo-filter-chip');
        if (!chip || !chip.dataset.brand) return;
        const brand = chip.dataset.brand;
        const idx = state.selectedBrands.indexOf(brand);
        if (idx >= 0) { state.selectedBrands.splice(idx, 1); }
        else { state.selectedBrands.push(brand); }
        state.displayedCount = 0;
        buildAvailableSizes();
        updateUI();
      });
    }
    
    // Type chips delegation
    const typeContainer = document.getElementById('filter-type-chips');
    if (typeContainer) {
      typeContainer.addEventListener('click', (e) => {
        const chip = e.target.closest('.bogo-filter-chip');
        if (!chip || !chip.dataset.type) return;
        state.selectedTypes[state.activeCategory] = chip.dataset.type;
        state.displayedCount = 0;
        updateUI();
      });
    }
    
    // Filter tags delegation (remove individual filters + clear all)
    const tagsContainer = document.getElementById('filter-tags-container');
    if (tagsContainer) {
      tagsContainer.addEventListener('click', (e) => {
        // Clear all button
        if (e.target.closest('.bogo-filter-tags__clear')) {
          state.selectedBrands = [];
          state.selectedTypes[state.activeCategory] = 'All';
          state.sortOrder = 'default';
          state.displayedCount = 0;
          buildAvailableSizes();
          updateUI();
          return;
        }
        // Individual tag removal
        const tag = e.target.closest('.bogo-filter-tag');
        if (!tag) return;
        const tagType = tag.dataset.tagType;
        const tagValue = tag.dataset.tagValue;
        if (tagType === 'brand') {
          state.selectedBrands = state.selectedBrands.filter(b => b !== tagValue);
          buildAvailableSizes();
        } else if (tagType === 'type') {
          state.selectedTypes[state.activeCategory] = 'All';
        } else if (tagType === 'sort') {
          state.sortOrder = 'default';
        }
        state.displayedCount = 0;
        updateUI();
      });
    }
    
    // History panel items delegation
    const historyList = document.getElementById('history-panel-list');
    if (historyList) {
      historyList.addEventListener('click', (e) => {
        const item = e.target.closest('.bogo-history__item');
        if (!item) return;
        const pid = parseInt(item.dataset.productId);
        const product = state.allProducts.find(p => p.id === pid);
        if (product) {
          closeHistoryPanel();
          openQuickView(product);
        }
      });
    }
    
    // Suggestions strip delegation
    const suggestStrip = document.getElementById('suggestions-strip');
    if (suggestStrip) {
      suggestStrip.addEventListener('click', (e) => {
        const card = e.target.closest('.bogo-suggest__card');
        if (!card) return;
        const pid = parseInt(card.dataset.productId);
        const product = state.allProducts.find(p => p.id === pid);
        if (product) openQuickView(product);
      });
    }
    
    // Recently viewed strip delegation
    const recentStrip = document.getElementById('recently-viewed-strip');
    if (recentStrip) {
      recentStrip.addEventListener('click', (e) => {
        const card = e.target.closest('.bogo-recent__card');
        if (!card) return;
        const pid = parseInt(card.dataset.productId);
        const product = state.allProducts.find(p => p.id === pid);
        if (product) openQuickView(product);
      });
    }

    // Size modal
    safeOn('size-selector-btn', 'click', openSizeModal);
    safeOn('empty-select-size-btn', 'click', openSizeModal);
    safeOn('size-modal-backdrop', 'click', closeSizeModal);
    safeOn('size-modal-close', 'click', closeSizeModal);
    safeOn('size-modal-done-btn', 'click', () => {
      closeSizeModal();
      scrollToProducts();
    });
    safeOn('size-modal-chart-link-footer', 'click', () => {
      closeSizeModal();
      openSizeChart();
    });

    // Quick view close
    const backBtn = document.getElementById('quickview-back');
    const closeBtn = document.getElementById('quickview-close');
    const backdrop = document.getElementById('quickview-backdrop');
    
    if (backBtn) backBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); closeQuickView(); });
    if (closeBtn) closeBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); closeQuickView(); });
    if (backdrop) backdrop.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); closeQuickView(); });
    
    safeOn('quickview-add-btn', 'click', addToBogoFromQuickView);
    safeOn('gallery-prev', 'click', () => navigateGallery(-1));
    safeOn('gallery-next', 'click', () => navigateGallery(1));
    
    // Size Chart
    safeOn('size-chart-btn', 'click', openSizeChart);
    
    // Filter panel toggle
    safeOn('filter-toggle-btn', 'click', toggleFilterPanel);
    safeOn('filter-panel-close', 'click', toggleFilterPanel);
    
    // Sort chips in filter panel
    const sortContainer = document.getElementById('filter-sort-chips');
    if (sortContainer) {
      sortContainer.addEventListener('click', (e) => {
        const chip = e.target.closest('.bogo-filter-chip');
        if (!chip || !chip.dataset.sort) return;
        state.sortOrder = chip.dataset.sort;
        state.displayedCount = 0;
        updateUI();
      });
    }
    
    // History & sizechart
    safeOn('bogo-history-btn', 'click', openHistoryPanel);
    safeOn('history-panel-close', 'click', closeHistoryPanel);
    safeOn('sizechart-close', 'click', closeSizeChart);
    safeOn('sizechart-backdrop', 'click', closeSizeChart);

    // Zoom
    safeOn('zoom-close', 'click', closeZoom);
    safeOn('zoom-prev', 'click', () => navigateZoom(-1));
    safeOn('zoom-next', 'click', () => navigateZoom(1));
    safeOn('zoom-body', 'dblclick', () => {
      const img = document.getElementById('zoom-image');
      if (img) img.style.transform = img.style.transform === 'scale(2.5)' ? 'scale(1)' : 'scale(2.5)';
    });

    // Bottom bar
    safeOn('clear-selection-btn', 'click', clearBogoSelection);
    safeOn('checkout-btn', 'click', addToCart);
    
    // Confirmation overlay
    safeOn('confirm-checkout-btn', 'click', proceedToCart);
    safeOn('confirm-cancel-btn', 'click', () => {
      const overlay = document.getElementById('bogo-confirm-overlay');
      if (overlay) overlay.style.display = 'none';
      unlockScroll();
    });

    // Replace modal (v5)
    safeOn('replace-slot1-btn', 'click', () => replaceSlot('first'));
    safeOn('replace-slot2-btn', 'click', () => replaceSlot('second'));
    safeOn('replace-cancel-btn', 'click', cancelReplace);

    // Load more
    safeOn('load-more-btn', 'click', loadMoreProducts);

    // Retry
    safeOn('retry-fetch-btn', 'click', () => {
      state.isFetched = false;
      state.fetchError = null;
      fetchAllProducts();
    });

    // Gallery swipe
    const gallery = document.getElementById('quickview-gallery');
    if (gallery) {
      let startX = 0, startY = 0;
      gallery.addEventListener('touchstart', e => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      gallery.addEventListener('touchmove', e => { const dx = Math.abs(e.touches[0].clientX - startX); const dy = Math.abs(e.touches[0].clientY - startY); if (dx > dy && dx > 10) e.preventDefault(); }, { passive: false });
      gallery.addEventListener('touchend', e => { const diff = startX - e.changedTouches[0].clientX; if (Math.abs(diff) > 50) navigateGallery(diff > 0 ? 1 : -1); });
    }

    // Zoom swipe
    const zoomBody = document.getElementById('zoom-body');
    if (zoomBody) {
      let startX = 0, startY = 0;
      zoomBody.addEventListener('touchstart', e => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      zoomBody.addEventListener('touchmove', e => { const dx = Math.abs(e.touches[0].clientX - startX); const dy = Math.abs(e.touches[0].clientY - startY); if (dx > dy && dx > 10) e.preventDefault(); }, { passive: false });
      zoomBody.addEventListener('touchend', e => { const diff = startX - e.changedTouches[0].clientX; if (Math.abs(diff) > 50) navigateZoom(diff > 0 ? 1 : -1); });
    }

    // Infinite scroll
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && state.displayedCount < state.filteredProducts.length) {
        loadMoreProducts();
      }
    }, { threshold: 0.1 });

    const loadMore = document.getElementById('bogo-load-more');
    if (loadMore) observer.observe(loadMore);

    // Keyboard
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        closeQuickView();
        closeZoom();
        closeSizeModal();
        closeSizeChart();
        cancelReplace();
      }
    });
  }

  // ===========================================
  // EXIT INTENT
  // ===========================================
  function setupExitIntent() {
    log('Exit intent: Setting up back-button guard');
    history.pushState({ bogoPage: true }, '', window.location.href);
    
    let exitModalShown = false;
    const myDomain = window.location.hostname;
    
    window.addEventListener('popstate', function(e) {
      if (exitModalShown) return;
      
      const referrer = document.referrer;
      const staysOnSite = referrer && referrer.includes(myDomain);
      
      if (staysOnSite) return;
      
      exitModalShown = true;
      history.pushState({ bogoPage: true }, '', window.location.href);
      
      const modal = document.getElementById('exit-intent-modal');
      if (modal) { modal.style.display = 'flex'; lockScroll(); }
    });
    
    document.addEventListener('click', function(e) {
      const stayBtn = e.target.closest('#exit-stay-btn');
      const leaveBtn = e.target.closest('#exit-leave-btn');
      
      if (stayBtn) {
        const modal = document.getElementById('exit-intent-modal');
        if (modal) modal.style.display = 'none';
        unlockScroll();
        exitModalShown = false;
      }
      
      if (leaveBtn) {
        const modal = document.getElementById('exit-intent-modal');
        if (modal) modal.style.display = 'none';
        unlockScroll();
        history.go(-2);
      }
    });
  }

  // ===========================================
  // INIT
  // ===========================================
  function init() {
    // Prevent double-init (theme editor re-renders, AJAX nav)
    if (window.__bogoInitDone) {
      log('BOGO already initialized, skipping');
      return;
    }
    window.__bogoInitDone = true;

    log('Initializing BOGO v4 — Multi-Collection + Brand-Aware...');
    
    const app = document.getElementById('bogo-app');
    if (!app) {
      console.error('BOGO: #bogo-app not found!');
      return;
    }

    // v4: Read multiple collection handles from data attributes
    const handlesStr = app.dataset.collectionHandles || '';
    const namesStr = app.dataset.collectionNames || '';
    
    state.collectionHandles = handlesStr.split(',').map(h => h.trim()).filter(Boolean);
    state.collectionNames = namesStr.split(',').map(n => n.trim()).filter(Boolean);
    
    log('Collection handles:', state.collectionHandles);
    log('Collection names:', state.collectionNames);

    if (state.collectionHandles.length === 0) {
      showError('No collections selected. Please go to Theme Editor and add BOGO collections.');
      return;
    }

    // Update hero subtitle with collection names if available
    const reasonEl = document.querySelector('.bogo-hero__reason');
    if (reasonEl && state.collectionNames.length > 0) {
      reasonEl.textContent = state.collectionNames.join(' · ') + ' — ⭐ 4.6 by 2,800+ buyers';
    }

    loadSchemaBrandCharts();
    bindEvents();
    fetchAllProducts();
    setupExitIntent();

    // ── Hero auto-collapse after 1 second ──
    var heroEl = document.querySelector('.bogo-hero');
    var scrollBtn = document.getElementById('bogo-scroll-btn');
    var stickyHeader = document.getElementById('bogo-sticky-header');

    function collapseHero() {
      if (heroEl) heroEl.classList.add('bogo-hero--collapsed');
    }

    // Auto-collapse after 1 second
    var heroCollapseTimer = setTimeout(collapseHero, 1000);

    // Manual "See Products" button
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function() {
        clearTimeout(heroCollapseTimer);
        collapseHero();
        setTimeout(function() {
          var target = stickyHeader || document.getElementById('bogo-grid');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      });
    }

    // Also collapse on any scroll
    var scrollCollapseOnce = function() {
      clearTimeout(heroCollapseTimer);
      collapseHero();
      window.removeEventListener('scroll', scrollCollapseOnce);
    };
    window.addEventListener('scroll', scrollCollapseOnce, { passive: true });

    // Inject spinner keyframes for loading states (used by proceedToCart, edit btn)
    if (!document.getElementById('bogo-spin-style')) {
      var styleEl = document.createElement('style');
      styleEl.id = 'bogo-spin-style';
      styleEl.textContent = '@keyframes bogo-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}';
      document.head.appendChild(styleEl);
    }

    // Sync BOGO state when user returns to tab (may have edited cart)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        syncCartState();
      }
    });

    // Also sync on cart drawer events (various theme patterns)
    ['cart:updated', 'cart:refresh', 'cart:close', 'ajaxCart:updated'].forEach(evt => {
      document.addEventListener(evt, () => {
        setTimeout(syncCartState, 500);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
